webpackJsonp([1],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TopNav_vue__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TopNav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_TopNav_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_BottomNav_vue__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_BottomNav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_BottomNav_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_social_vue__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_social_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__helpers_social_vue__);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TopNav: __WEBPACK_IMPORTED_MODULE_0__components_TopNav_vue___default.a,
    BottomNav: __WEBPACK_IMPORTED_MODULE_1__components_BottomNav_vue___default.a,
    Social: __WEBPACK_IMPORTED_MODULE_2__helpers_social_vue___default.a
  },

  data: function data() {
    return {
      colors: {
        visit: '#c21f25',
        exhibitions: '#fe0000',
        programs: '#c98313',
        collection: '#2aa800',
        library: '#1d9cbf',
        learn: '#2340e1',
        support: '#6876e8',
        about: '#8f9294'
      }
    };
  },


  watch: {
    loading: function loading() {
      if (!this.loading && this.key !== 'search' && this.key !== 'home' && this.key !== 'upcoming' && this.key) {
        document.title = 'CAAM | ' + this.loadedData[this.key].content.title;
      } else if (this.key === 'search') {
        document.title = 'CAAM | Search';
      } else {
        document.title = 'CAAM | California African American Museum';
      }
    }
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      error: null,
      loading: true,
      loadedData: {},
      progress: 0
    };
  },


  methods: {
    setLoading: function setLoading(loading) {
      this.loading = loading;
    },
    setData: function setData(path, data) {
      this.loadedData = {};
      this.loadedData[path] = data;
    },
    cashData: function cashData(path, data) {
      var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    },
    setError: function setError(error) {
      this.error = error;
    },
    getUrl: function getUrl(path) {
      var baseUrl = 'https://caamuseum.org/sirvy/';
      return baseUrl + path;
    },
    cashChildren: function cashChildren(data) {},
    requestData: function requestData(path) {
      var service = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'tree';
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var lsPath = path.replace('/', '-');
      var data = this.$ls.get(lsPath);
      params['service'] = service;
      if (!data) {
        this.request('get', path, params);
      } else {
        this.setData(path, data);
        this.setLoading(false);
      }
    },
    request: function request(method, path) {
      var _this = this;

      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var url = this.getUrl(path);
      this.error = null;
      this.setLoading(true);

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a[method](url, { params: params }).then(function (response) {
        _this.cashData(path, response.data);
        _this.setData(path, response.data);
        _this.setLoading(false);
      }).catch(function (error) {
        _this.setError(error);
      });
    },
    post: function post(url, data, callback) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data)).then(function (response) {
        callback(response);
      }).catch(function (error) {
        console.log(error);
      });
    },
    get: function get(url, callback) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url).then(function (response) {
        callback(response);
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Article__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Article___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Article__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Blog__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Blog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Blog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Error__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Exhibition__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Exhibition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Exhibition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Exhibitions__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Exhibitions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Exhibitions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ExhibitionsOverview__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ExhibitionsOverview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_ExhibitionsOverview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_GenericIndex__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_GenericIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_GenericIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Home__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_InfoPage__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_InfoPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_InfoPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Program__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Program___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Program__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Programs__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Programs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Programs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_ProgramsOverview__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_ProgramsOverview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_ProgramsOverview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Search__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Search__);

















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    name: 'home',
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Home___default.a
  }, {
    name: 'visit',
    path: '/visit',
    component: __WEBPACK_IMPORTED_MODULE_8__components_GenericIndex___default.a
  }, {
    name: 'visit-page',
    path: '/visit/:id',
    component: __WEBPACK_IMPORTED_MODULE_10__components_InfoPage___default.a
  }, {
    name: 'visit-page-subpage',
    path: '/visit/:id/:subid',
    component: __WEBPACK_IMPORTED_MODULE_10__components_InfoPage___default.a
  }, {
    name: 'exhibitions',
    path: '/exhibitions',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Exhibitions___default.a
  }, {
    name: 'exhibitions-overview',
    path: '/exhibitions/:year',
    component: __WEBPACK_IMPORTED_MODULE_7__components_ExhibitionsOverview___default.a
  }, {
    name: 'exhibition-single',
    path: '/exhibitions/:year/:id',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Exhibition___default.a
  }, {
    name: 'programs',
    path: '/programs',
    component: __WEBPACK_IMPORTED_MODULE_12__components_Programs___default.a
  }, {
    name: 'programs-overview',
    path: '/programs/:category',
    component: __WEBPACK_IMPORTED_MODULE_13__components_ProgramsOverview___default.a
  }, {
    name: 'programs-page',
    path: '/programs/:category/:id',
    component: __WEBPACK_IMPORTED_MODULE_11__components_Program___default.a
  }, {
    name: 'collection',
    path: '/collection',
    component: __WEBPACK_IMPORTED_MODULE_8__components_GenericIndex___default.a
  }, {
    name: 'collection-page',
    path: '/collection/:id',
    component: __WEBPACK_IMPORTED_MODULE_10__components_InfoPage___default.a
  }, {
    name: 'collection-page-subpage',
    path: '/collection/:id/:subid',
    component: __WEBPACK_IMPORTED_MODULE_10__components_InfoPage___default.a
  }, {
    name: 'library',
    path: '/library',
    component: __WEBPACK_IMPORTED_MODULE_8__components_GenericIndex___default.a
  }, {
    name: 'library-page',
    path: '/library/:id',
    component: __WEBPACK_IMPORTED_MODULE_10__components_InfoPage___default.a
  }, {
    name: 'library-page-subpage',
    path: '/library/:id/:subid',
    component: __WEBPACK_IMPORTED_MODULE_10__components_InfoPage___default.a
  }, {
    name: 'learn',
    path: '/learn',
    component: __WEBPACK_IMPORTED_MODULE_8__components_GenericIndex___default.a
  }, {
    name: 'blog',
    path: '/learn/600state',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Blog___default.a
  }, {
    name: 'blog-category',
    path: '/learn/600state/:category',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Blog___default.a
  }, {
    name: 'article',
    path: '/learn/600state/:category/:article',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Article___default.a
  }, {
    name: 'learn-page',
    path: '/learn/:id',
    component: __WEBPACK_IMPORTED_MODULE_10__components_InfoPage___default.a
  }, {
    name: 'learn-page-subpage',
    path: '/learn/:id/:subid',
    component: __WEBPACK_IMPORTED_MODULE_10__components_InfoPage___default.a
  }, {
    name: 'support',
    path: '/support',
    component: __WEBPACK_IMPORTED_MODULE_8__components_GenericIndex___default.a
  }, {
    name: 'support-page',
    path: '/support/:id',
    component: __WEBPACK_IMPORTED_MODULE_10__components_InfoPage___default.a
  }, {
    name: 'support-page-subpage',
    path: '/support/:id/:subid',
    component: __WEBPACK_IMPORTED_MODULE_10__components_InfoPage___default.a
  }, {
    name: 'about',
    path: '/about',
    component: __WEBPACK_IMPORTED_MODULE_8__components_GenericIndex___default.a
  }, {
    name: 'about-page',
    path: '/about/:id',
    component: __WEBPACK_IMPORTED_MODULE_10__components_InfoPage___default.a
  }, {
    name: 'about-page-subpage',
    path: '/about/:id/:subid',
    component: __WEBPACK_IMPORTED_MODULE_10__components_InfoPage___default.a
  }, {
    name: 'search',
    path: '/search',
    component: __WEBPACK_IMPORTED_MODULE_14__components_Search___default.a
  }, {
    path: '/a',
    redirect: '/b'
  }, {
    name: '404',
    path: '*',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Error___default.a
  }]
}));

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(181)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(94),
  /* template */
  __webpack_require__(244),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ie_array_find_polyfill__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ie_array_find_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ie_array_find_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_ls__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_ls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_ls__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_analytics__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_visual__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_visual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_visual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_progressbar__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_progressbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_progressbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_awesome_swiper__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vee_validate__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vee_validate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vee_validate__);













__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('visual', __WEBPACK_IMPORTED_MODULE_7_vue_visual___default.a);

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_ls___default.a, {
  namespace: '_caam_'
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_progressbar___default.a, {
  color: '#FFFFFF',
  failedColor: '#874b4b',
  thickness: '0.5vH',
  transition: {
    speed: '0.05s',
    opacity: '0s',
    termination: 300
  },
  autoRevert: true,
  location: 'top',
  inverse: false
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_awesome_swiper___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vee_validate___default.a);

__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].beforeEach(function (to, from, next) {
  window.scrollTo(0, 0);
  next();
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_analytics___default.a, {
  id: 'UA-103658114-1',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */]
});

new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App___default.a }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_marked__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_marked__);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    compiledMarkdown: function compiledMarkdown(markdown) {
      return __WEBPACK_IMPORTED_MODULE_0_marked___default()(markdown, { sanitize: true });
    },

    slugify: function slugify(str) {
      var first = str.replace(/['*+~, .()"!:@]/g, '-').toLowerCase();
      return first.replace(/^-+|-+(?=-|$)/g, '');
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },

  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var browser = typeof window !== 'undefined';
if (browser) {
  window.Swiper = __webpack_require__(57);
  __webpack_require__(161);
}
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function mount() {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    };
    this.options.notNextTick ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BasicInput__ = __webpack_require__(37);




/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__BasicInput__["a" /* default */]]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BasicInput__ = __webpack_require__(37);




/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__BasicInput__["a" /* default */]],

  props: {
    alignment: String
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BasicInput__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SingleInput__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SingleInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SingleInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WrapperInput__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WrapperInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__WrapperInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_flatpickr__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_flatpickr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_flatpickr__);








/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__BasicInput__["a" /* default */]],

  props: {
    alignment: String,
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  components: {
    SingleInput: __WEBPACK_IMPORTED_MODULE_2__SingleInput___default.a,
    WrapperInput: __WEBPACK_IMPORTED_MODULE_3__WrapperInput___default.a
  },

  data: function data() {
    return {
      datepicker: null,
      selectedDates: null
    };
  },
  mounted: function mounted() {
    if (!this.datepicker) {
      this.config.onValueUpdate = this.dateUpdated;
      this.datepicker = new __WEBPACK_IMPORTED_MODULE_4_flatpickr___default.a(this.$el, this.config);
      this.setDate(this.value);
    }
    this.$watch('config', this.redraw);
    this.$watch('value', this.setDate);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.datepicker && !this.static) {
      this.datepicker.destroy();
      this.datepicker = null;
    }
  },


  methods: {
    redraw: function redraw(newConfig) {
      this.datepicker.config = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.datepicker.config, newConfig);
      this.datepicker.redraw();
      this.datepicker.jumpToDate();
    },
    setDate: function setDate(newDate, oldDate) {
      newDate && this.datepicker.setDate(newDate);
    },
    dateUpdated: function dateUpdated(selectedDates, dateStr) {
      this.date = dateStr;
    }
  },

  computed: {
    wrap: function wrap() {
      return !!this.config.wrap;
    },
    static: function _static() {
      return !!this.config.static;
    },
    name: function name() {
      return this.wrap ? 'wrapperInput' : 'singleInput';
    },

    date: {
      get: function get() {
        return this.selectedDates || this.value;
      },
      set: function set(newValue) {
        if (this.selectedDates !== newValue) {
          this.selectedDates = newValue;
          this.$emit('input', newValue);
        }
      }
    }
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var inBrowser = typeof window !== 'undefined';
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'VueProgress',
    serverCacheKey: function serverCacheKey() {
        return 'Progress';
    },
    computed: {
        style: function style() {
            var location = this.progress.options.location;
            var style = {
                'background-color': this.progress.options.canSuccess ? this.progress.options.color : this.progress.options.failedColor,
                'opacity': this.progress.options.show ? 1 : 0
            };
            if (location == 'top' || location == 'bottom') {
                location === 'top' ? style.top = '0px' : style.bottom = '0px';
                if (!this.progress.options.inverse) {
                    style.left = '0px';
                } else {
                    style.right = '0px';
                }
                style.width = this.progress.percent + '%';
                style.height = this.progress.options.thickness;
                style.transition = "width " + this.progress.options.transition.speed + ", opacity " + this.progress.options.transition.opacity;
            } else if (location == 'left' || location == 'right') {
                location === 'left' ? style.left = '0px' : style.right = '0px';
                if (!this.progress.options.inverse) {
                    style.bottom = '0px';
                } else {
                    style.top = '0px';
                }
                style.height = this.progress.percent + '%';
                style.width = this.progress.options.thickness;
                style.transition = "height " + this.progress.options.transition.speed + ", opacity " + this.progress.options.transition.opacity;
            }
            return style;
        },
        progress: function progress() {
            if (inBrowser) {
                return window.VueProgressBarEventBus.RADON_LOADING_BAR;
            } else {
                return {
                    percent: 0,
                    options: {
                        canSuccess: true,
                        show: false,
                        color: 'rgb(19, 91, 55)',
                        failedColor: 'red',
                        thickness: '2px',
                        transition: {
                            speed: '0.2s',
                            opacity: '0.6s',
                            termination: 300
                        },
                        location: 'top',
                        autoRevert: true,
                        inverse: false
                    }
                };
            }
        }
    }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  created: function created() {
    localStorage.clear();
    var mq = window.matchMedia('only screen and (max-width: 35.5em)');
    mq.addListener(this.mobile);
    this.mobile(mq);
  },


  methods: {
    mobile: function mobile(mql) {
      if (mql.matches) {
        window._caam_intro = false;
        window._caam_introBG = false;
      } else {
        window._caam_intro = true;
        window._caam_introBG = true;
      }
    }
  }
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_DataMixin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_ComponentMixin__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'article',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_DataMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_ComponentMixin__["a" /* default */]],

  data: function data() {
    return {
      share: false
    };
  },
  mounted: function mounted() {
    this.requestData(this.key, 'article');
  },


  computed: {
    key: function key() {
      var path = this.$route.path.substring(1).split('/');
      path.splice(2, 1);
      return path.join('/');
    },

    content: function content() {
      return this.loadedData[this.key].content;
    },

    files: function files() {
      return this.loadedData[this.key].files;
    },

    title: function title() {
      return this.content.title;
    },

    hero: function hero() {
      var name = this.content.main_image;
      return this.files.find(function (item) {
        return item.filename === name;
      });
    },

    heroCaption: function heroCaption() {
      return this.hero.meta.caption;
    },

    captions: function captions() {
      var captionString = '';
      if (this.hero) {
        var caption = this.hero.meta.caption;
        var credit = this.hero.meta.credit;

        if (caption) {
          captionString += caption + '. ';
        }
        if (credit) {
          captionString += credit + '.';
        }

        return captionString;
      } else {
        return false;
      }
    },

    text: function text() {
      return this.content.text;
    },

    author: function author() {
      return this.content.author;
    },

    date: function date() {
      return this.content.date;
    },

    relatedArticles: function relatedArticles() {
      if (this.loadedData[this.key].related_articles) {
        return this.loadedData[this.key].related_articles;
      }
      return [];
    },

    relatedExhibitions: function relatedExhibitions() {
      if (this.loadedData[this.key].related_exhibitions) {
        return this.loadedData[this.key].related_exhibitions;
      }
      return [];
    },

    shareInfo: function shareInfo() {
      var data = {
        url: window.location.href,
        title: this.title,
        description: this.text,
        image: this.hero.url
      };
      return data;
    }
  },

  methods: {
    checkTitle: function checkTitle(post) {
      if (post.content.short_title) {
        if (post.content.short_title.length > 0) {
          return post.content.short_title;
        } else {
          return post.content.title;
        }
      } else {
        return post.content.title;
      }
    },

    relatedExhibitionDate: function relatedExhibitionDate(ex) {
      var start = '';

      if (ex.content.start_year !== ex.content.end_year) {
        start = ex.content.start_date + ', ' + ex.content.start_year;
      } else {
        start = ex.content.start_date;
      }
      var end = ex.content.end_date + ', ' + ex.content.end_year;
      return start + ' - ' + end;
    },

    year: function year(exhibition) {
      return exhibition.content.start_year;
    }
  },

  watch: {
    $route: function $route() {
      this.requestData(this.key, 'article');
    }
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_DataMixin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_ComponentMixin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_UtilsMixin__ = __webpack_require__(87);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'blog',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_DataMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_ComponentMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_UtilsMixin__["a" /* default */]],

  data: function data() {
    return {
      loading: false,
      loadedData: [],
      catSlug: false,

      url: 'https://caamuseum.org/api/articles',
      offset: 0,
      limit: 10,
      currentIndex: 0
    };
  },
  created: function created() {
    this.catSlug = this.$route.params.category;
    this.getData();
  },


  methods: {
    active: function active(num) {
      return num === this.currentIndex;
    },

    categoryLink: function categoryLink(cat) {
      return {
        name: 'blog-category',
        params: {
          category: this.slugify(cat)
        }
      };
    },

    catActive: function catActive(cat) {
      return this.slugify(cat) === this.catSlug;
    },

    getCat: function getCat(post) {
      var cat = void 0;
      if (post.content.category && !this.catSlug) {
        cat = post.content.category.split(', ')[0];
      } else if (this.catSlug) {
        cat = this.catSlug;
      } else {
        cat = 'black-history';
      }
      return this.slugify(cat);
    },


    getData: function getData() {
      var _this = this;

      var page = '?offset=' + this.offset + '&limit=' + this.limit;
      var url = this.catSlug ? this.url + '/' + this.catSlug + page : this.url + page;
      this.loading = true;
      this.get(url, function (response) {
        _this.loading = false;
        _this.loadedData = response.data;
      });
    },

    hero: function hero(post) {
      var name = post.content.main_image;
      var files = post.files;
      if (name.length > 0) {
        return files.find(function (item) {
          return item.filename === name;
        });
      } else {
        return false;
      }
    },

    heroImage: function heroImage(post) {
      var hero = this.hero(post);
      return hero.url;
    },


    heroCaption: function heroCaption(post) {
      var hero = this.hero(post);
      return hero.meta.caption;
    },

    checkTitle: function checkTitle(post) {
      if (post.content.short_title) {
        if (post.content.short_title.length > 0) {
          return post.content.short_title;
        } else {
          return post.content.title;
        }
      } else {
        return post.content.title;
      }
    },

    loadPage: function loadPage(num) {
      this.currentIndex = num;
      this.offset = num * this.limit;
      this.getData();
      window.scrollTo(0, 0);
    }
  },

  computed: {
    categories: function categories() {
      return this.loadedData.categories.split(',');
    },

    description: function description() {
      return this.loadedData.description;
    },

    featuredMain: function featuredMain() {
      return this.loadedData.featured[0];
    },

    featured: function featured() {
      var fC = this.loadedData.featured ? [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.loadedData.featured)) : [];
      return fC.slice(1);
    },

    featuredActive: function featuredActive() {
      return this.loadedData.featured_active;
    },

    posts: function posts() {
      return this.loadedData.posts;
    },

    numPages: function numPages() {
      var total = Math.ceil(this.loadedData.total / this.limit);
      return total <= 1 ? [] : [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(Array(total).keys()));
    }
  },

  watch: {
    loaded: function loaded() {
      if (this.loaded) {
        window.scrollTo(0, 0);
      }
    },
    $route: function $route() {
      this.catSlug = this.$route.params.category;
      this.getData();
    }
  }
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_DataMixin__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'bottom-nav',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_DataMixin__["a" /* default */]],
  props: ['footerColor'],
  data: function data() {
    return {
      menu: false,
      active: null,
      subscribe: false,
      email: null,
      first: null,
      last: null,
      zip: null,
      message: false,
      roots: [],
      whiteFooter: false
    };
  },
  created: function created() {
    this.requestData('root', 'root');
    this.whiteFooter = this.footerColor === 'white';
    window.addEventListener('resize', this.logoResize);
  },
  mounted: function mounted() {
    var _this = this;

    var int = setInterval(function () {
      var lb = document.getElementById('logo-bottom');
      if (lb != null) {
        _this.logoResize();
        clearInterval(int);
      }
    }, 50);
  },


  destroyed: function destroyed() {
    window.removeEventListener('resize', this.logoResize);
  },

  computed: {
    insta: function insta() {
      var l = '/static/icons/';
      return this.whiteFooter ? l + 'instagram.svg' : l + 'instagram_white.svg';
    },
    twitter: function twitter() {
      var l = '/static/icons/';
      return this.whiteFooter ? l + 'twitter.svg' : l + 'twitter_white.svg';
    },
    youtube: function youtube() {
      var l = '/static/icons/';
      return this.whiteFooter ? l + 'youtube.svg' : l + 'youtube_white.svg';
    },
    facebook: function facebook() {
      var l = '/static/icons/';
      return this.whiteFooter ? l + 'facebook.svg' : l + 'facebook_white.svg';
    }
  },

  methods: {
    submit: function submit() {
      var _this2 = this;

      var url = 'https://caamuseum.org/api/newsletter';

      var data = {
        email: this.email,
        first: this.first,
        last: this.last,
        zip: this.zip
      };

      this.post(url, data, function (response) {
        _this2.message = response.data.message;
      });
    },

    logoResize: function logoResize() {
      var height = document.getElementById('logo-bottom').clientHeight;
      document.getElementById('slogan-bottom').style.height = height + 'px';
    },

    xOut: function xOut() {
      this.subscribe = false;
      this.message = false;
      this.email = null;
      this.first = null;
      this.last = null;
      this.zip = null;
    },

    rotate: function rotate(matrix) {
      var result = [];

      var _loop = function _loop(i) {
        var row = matrix.map(function (e) {
          return e[i];
        }).reverse();
        result.push(row);
      };

      for (var i = 0; i < matrix[0].length; i++) {
        _loop(i);
      }
      return result;
    },

    mapRoot: function mapRoot() {
      var arr = this.loadedData.root;

      var chunks = [[arr[0], arr[3], arr[6]], [arr[1], arr[4], arr[7]], [arr[2], arr[5]]];

      return chunks;
    },

    formatRoute: function formatRoute(item) {
      return item.replace(/ |'/g, '-').toLowerCase();
    }
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_ComponentMixin__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'error',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_ComponentMixin__["a" /* default */]]
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_DataMixin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_ComponentMixin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dateformat__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dateformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_dateformat__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'exhibition',
  key: null,
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_DataMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_ComponentMixin__["a" /* default */]],

  data: function data() {
    var _this = this;

    return {
      galleryFS: false,
      galleryIndex: 1,
      share: false,
      swiperOption: {
        notNextTick: true,
        autoplay: false,
        direction: 'horizontal',
        prevButton: '.swiper-button-prev',
        nextButton: '.swiper-button-next',
        mousewheelControl: false,
        observeParents: true,
        debugger: false,
        onSlideChangeEnd: function onSlideChangeEnd(swiper) {
          _this.galleryIndex = swiper.realIndex + 1;
        },
        onInit: function onInit(swiper) {
          swiper.slideTo(_this.galleryIndex - 1, 0, false);
        }
      }
    };
  },
  created: function created() {
    this.key = 'exhibitions/' + this.$route.params.year + '/' + this.$route.params.id;
    this.requestData(this.key, 'exhibition');
  },


  methods: {
    checkTitle: function checkTitle(post) {
      if (post.content.short_title) {
        if (post.content.short_title.length > 0) {
          return post.content.short_title;
        } else {
          return post.content.title;
        }
      } else {
        return post.content.title;
      }
    },

    programDate: function programDate(date) {
      if (date) {
        var d = new Date(date);
        return __WEBPACK_IMPORTED_MODULE_3_dateformat___default()(d, 'dddd, mmmm d, yyyy');
      } else {
        return '';
      }
    },

    articleDate: function articleDate(date) {
      if (date) {
        return this.formatDate(date);
      } else {
        return '';
      }
    },

    fullscreen: function fullscreen() {
      this.galleryFS = !this.galleryFS;
      if (this.galleryFS) {
        document.getElementById('header').style['z-index'] = -1;
      } else {
        document.getElementById('header').style['z-index'] = 9999;
      }
    },

    formatDate: function formatDate(dateString) {
      var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      var dateArray = dateString.split('-');
      var day = dateArray[2];
      var month = months[parseInt(dateArray[1]) - 1];
      var year = dateArray[0];
      var date = month + ' ' + day + ', ' + year;
      return date;
    }
  },

  computed: {
    content: function content() {
      return this.loadedData[this.key].content;
    },

    startDate: function startDate() {
      return this.content.start_date;
    },

    endDate: function endDate() {
      return this.content.end_date;
    },

    startYear: function startYear() {
      return this.content.start_year;
    },

    endYear: function endYear() {
      return this.content.end_year;
    },

    date: function date() {
      var endDate = this.endDate + ', ' + this.endYear;
      var startDate = startDate = this.startDate;
      if (this.endYear !== this.startYear) {
        startDate = this.startDate + ', ' + this.startYear;
      }
      return startDate + ' - ' + endDate;
    },

    displayDate: function displayDate() {
      var dd = this.content.display_date;
      return !!dd ? dd : this.date;
    },


    status: function status() {
      return this.content.status;
    },

    title: function title() {
      return this.content.title;
    },

    teaser: function teaser() {
      return this.content.teaser;
    },

    text: function text() {
      return this.content.text;
    },

    resources: function resources() {
      return this.content.resources;
    },

    press: function press() {
      return this.content.press;
    },

    files: function files() {
      return this.loadedData[this.key].files;
    },

    hero: function hero() {
      var name = this.content.main_image;
      if (name.length > 0) {
        return this.files.find(function (item) {
          return item.filename === name;
        });
      } else {
        return false;
      }
    },

    captions: function captions() {
      var captionString = '';
      if (this.hero) {
        var caption = this.hero.meta.caption;
        var credit = this.hero.meta.credit;

        if (caption) {
          captionString += caption + '. ';
        }
        if (credit) {
          captionString += credit + '.';
        }

        return captionString;
      } else {
        return false;
      }
    },

    gallery: function gallery() {
      var _this2 = this;

      if (this.content.gallery) {
        var _ret = function () {
          var names = _this2.content.gallery.split(',');
          var i = names.length;
          var files = [];
          while (i--) {
            files.push(_this2.files.find(function (item) {
              return item.filename === names[i];
            }));
          }
          return {
            v: files.reverse()
          };
        }();

        if ((typeof _ret === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_ret)) === "object") return _ret.v;
      } else {
        return [];
      }
    },

    galleryCaption: function galleryCaption() {
      var item = this.gallery[this.galleryIndex - 1];
      var captionData = item.meta.caption;
      var creditData = item.meta.credit;
      var caption = '';
      var credit = '';

      if (captionData) {
        caption = captionData + '. ';
      }
      if (creditData) {
        credit = creditData + '.';
      }

      return { caption: caption, credit: credit };
    },

    numGalleryItems: function numGalleryItems() {
      return this.gallery.length;
    },

    relatedPrograms: function relatedPrograms() {
      return this.loadedData[this.key].programs;
    },

    relatedArticles: function relatedArticles() {
      if (this.loadedData[this.key].related_articles) {
        return this.loadedData[this.key].related_articles;
      }
      return [];
    },

    curator: function curator() {
      var curator = this.content.curator;
      return curator.length > 0 ? curator : false;
    },

    shareInfo: function shareInfo() {
      var data = {
        url: this.loadedData[this.key].url,
        title: this.title,
        description: this.text,
        image: this.hero.url
      };
      return data;
    }
  }
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_DataMixin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_ComponentMixin__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'exhibitions',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_DataMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_ComponentMixin__["a" /* default */]],

  created: function created() {
    this.loading = false;
    this.requestData('exhibitions', 'exhibitions');
  },


  methods: {
    startDate: function startDate(exhibition) {
      return exhibition.content.start_date;
    },

    endDate: function endDate(exhibition) {
      return exhibition.content.end_date;
    },

    startYear: function startYear(exhibition) {
      return exhibition.content.start_year;
    },

    endYear: function endYear(exhibition) {
      return exhibition.content.end_year;
    },

    date: function date(exhibition) {
      var endDate = this.endDate(exhibition) + ', ' + this.endYear(exhibition);
      var startDate = this.startDate(exhibition);
      if (this.endYear(exhibition) !== this.startYear(exhibition)) {
        startDate = this.startDate(exhibition) + ', ' + this.startYear(exhibition);
      }
      return startDate + ' - ' + endDate;
    },

    displayDate: function displayDate(exhibition) {
      var dd = exhibition.content.display_date;
      return !!dd ? dd : this.date(exhibition);
    },


    title: function title(exhibition) {
      return exhibition.content.title;
    }
  },

  computed: {
    current: function current() {
      var data = this.loadedData.exhibitions.current;
      var main = data.splice(0, 1)[0];
      var current = {
        main: main,
        exhibitions: data
      };
      return current;
    },

    traveling: function traveling() {
      if (this.loadedData.exhibitions.traveling.length === 0) {
        return false;
      } else {
        return this.loadedData.exhibitions.traveling;
      }
    },

    upcoming: function upcoming() {
      return this.loadedData.exhibitions.upcoming;
    },

    upcomingHero: function upcomingHero() {
      if (this.upcoming.length > 0) {
        return this.upcoming[0].image;
      } else {
        return false;
      }
    },

    past: function past() {
      return this.loadedData.exhibitions.past;
    },

    key: function key() {
      return 'exhibitions';
    },

    pastFeatured: function pastFeatured() {
      return this.loadedData.exhibitions.past_featured;
    },

    travelingFeatured: function travelingFeatured() {
      return this.loadedData.exhibitions.traveling_featured;
    },

    upcomingFeatured: function upcomingFeatured() {
      return this.loadedData.exhibitions.upcoming_featured;
    },

    altText: function altText() {
      return this.current.main.title;
    }
  },

  watch: {
    $route: function $route() {
      if (this.$route.query.status === 'past') {
        this.$router.replace({ name: 'exhibitions-overview', params: { year: 'past' } });
      } else if (this.$route.query.status === 'traveling') {
        this.$router.replace({ name: 'exhibitions-overview', params: { year: 'traveling' } });
      } else if (this.$route.query.status === 'future') {
        if (!this.loading) {
          document.getElementById('future').scrollIntoView();
          window.scrollBy(0, -150);
        }
      }
    }
  },

  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (to.query.status === 'past') {
      next(function (vm) {
        vm.$router.replace({ name: 'exhibitions-overview', params: { year: 'past' } });
      });
    } else if (to.query.status === 'traveling') {
      next(function (vm) {
        vm.$router.replace({ name: 'exhibitions-overview', params: { year: 'traveling' } });
      });
    } else if (to.query.status === 'future') {
      next(function (vm) {
        if (!vm.loading) {
          document.getElementById('future').scrollIntoView();
          window.scrollBy(0, -150);
        }
      });
    }
    next();
  }
});

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_ComponentMixin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ExhibitionsYear__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ExhibitionsYear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ExhibitionsYear__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ExhibitionsPast__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ExhibitionsPast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ExhibitionsPast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ExhibitionsTraveling__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ExhibitionsTraveling___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ExhibitionsTraveling__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ExhibitionsUpcoming__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ExhibitionsUpcoming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_ExhibitionsUpcoming__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'exhibitions-overview',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_ComponentMixin__["a" /* default */]],
  components: {
    ExhibitionsPast: __WEBPACK_IMPORTED_MODULE_2__components_ExhibitionsPast___default.a,
    ExhibitionsYear: __WEBPACK_IMPORTED_MODULE_1__components_ExhibitionsYear___default.a,
    ExhibitionsTraveling: __WEBPACK_IMPORTED_MODULE_3__components_ExhibitionsTraveling___default.a,
    ExhibitionsUpcoming: __WEBPACK_IMPORTED_MODULE_4__components_ExhibitionsUpcoming___default.a
  },

  computed: {
    param: function param() {
      return this.$route.params.year;
    }
  }
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_DataMixin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_ComponentMixin__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'exhibitions-past',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_DataMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_ComponentMixin__["a" /* default */]],

  created: function created() {
    this.requestData('exhibitions', 'exhibitions');
    window.scrollTo(0, 0);
  },


  methods: {},

  computed: {
    years: function years() {
      var today = new Date();
      var year = today.getFullYear();
      return this.loadedData.exhibitions.years.filter(function (y) {
        return parseInt(y.title) < parseInt(year);
      });
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_DataMixin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_ComponentMixin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dateformat__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dateformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_dateformat__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'exhibitions-traveling',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_DataMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_ComponentMixin__["a" /* default */]],

  data: function data() {
    return {
      loading: false,
      loadedData: [],

      url: 'https://caamuseum.org/api/exhibitions-traveling/'
    };
  },
  created: function created() {
    this.key = 'traveling';
    this.getData();
  },


  methods: {
    getData: function getData() {
      var _this = this;

      this.loading = true;
      this.get(this.url, function (response) {
        _this.loading = false;
        _this.loadedData = response.data;
      });
    },

    hero: function hero(image, files) {
      return files.find(function (item) {
        return item.filename === image;
      });
    },

    startDate: function startDate(date) {
      if (date) {
        var d = new Date(date);
        return __WEBPACK_IMPORTED_MODULE_2_dateformat___default()(d, 'mmmm d');
      } else {
        return '';
      }
    },

    endDate: function endDate(date) {
      if (date) {
        var d = new Date(date);
        return __WEBPACK_IMPORTED_MODULE_2_dateformat___default()(d, 'mmmm d, yyyy');
      } else {
        return '';
      }
    },

    displayDate: function displayDate(exhibition) {
      var dd = exhibition.content.display_date;
      console.log(dd);
      var date = exhibition.content.start_date + ' - ' + exhibition.content.end_date;
      return !!dd ? dd : date;
    },


    year: function year(date) {
      if (date) {
        var d = new Date(date);
        return __WEBPACK_IMPORTED_MODULE_2_dateformat___default()(d, 'yyyy');
      } else {
        return '';
      }
    }
  },

  computed: {
    exhibitions: function exhibitions() {
      return this.loadedData[this.key];
    },

    parameter: function parameter() {
      return this.$route.params.year;
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_DataMixin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_ComponentMixin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dateformat__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dateformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_dateformat__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'exhibitions-upcoming',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_DataMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_ComponentMixin__["a" /* default */]],

  data: function data() {
    return {
      loading: false,
      loadedData: [],

      url: 'https://caamuseum.org/api/exhibitions-upcoming/'
    };
  },
  created: function created() {
    this.key = 'upcoming';
    this.getData();
  },


  methods: {
    getData: function getData() {
      var _this = this;

      this.loading = true;
      this.get(this.url, function (response) {
        _this.loading = false;
        _this.loadedData = response.data;
      });
    },

    hero: function hero(image, files) {
      return files.find(function (item) {
        return item.filename === image;
      });
    },

    startDate: function startDate(date) {
      if (date) {
        var d = new Date(date);
        return __WEBPACK_IMPORTED_MODULE_2_dateformat___default()(d, 'mmmm d');
      } else {
        return '';
      }
    },

    endDate: function endDate(date) {
      if (date) {
        var d = new Date(date);
        return __WEBPACK_IMPORTED_MODULE_2_dateformat___default()(d, 'mmmm d, yyyy');
      } else {
        return '';
      }
    },

    displayDate: function displayDate(exhibition) {
      var dd = exhibition.content.display_date;
      console.log(dd);
      var date = exhibition.content.start_date + ' - ' + exhibition.content.end_date;
      return !!dd ? dd : date;
    },


    year: function year(date) {
      if (date) {
        var d = new Date(date);
        return __WEBPACK_IMPORTED_MODULE_2_dateformat___default()(d, 'yyyy');
      } else {
        return '';
      }
    }
  },

  computed: {
    exhibitions: function exhibitions() {
      return this.loadedData[this.key];
    },

    parameter: function parameter() {
      return this.$route.params.year;
    }
  }
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_DataMixin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_ComponentMixin__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'exhibitions-year',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_DataMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_ComponentMixin__["a" /* default */]],

  created: function created() {
    this.key = 'exhibitions/' + this.year;
    this.requestData(this.key, 'children');
  },


  methods: {

    hero: function hero(exhibition) {
      if (exhibition.hero_cropped_sq !== '') {
        return exhibition.hero_cropped_sq.url;
      } else if (exhibition.main_image !== '') {
        return exhibition.main_image.url;
      } else {
        return false;
      }
    },

    altText: function altText(exhibition) {
      return exhibition.title;
    },

    startDate: function startDate(exhibition) {
      return exhibition.content.start_date;
    },

    endDate: function endDate(exhibition) {
      return exhibition.content.end_date;
    },

    startYear: function startYear(exhibition) {
      return exhibition.content.start_year;
    },

    endYear: function endYear(exhibition) {
      return exhibition.content.end_year;
    },

    date: function date(exhibition) {
      var endDate = this.endDate(exhibition) + ', ' + this.endYear(exhibition);
      var startDate = startDate = this.startDate(exhibition);
      if (this.endYear(exhibition) !== this.startYear(exhibition)) {
        startDate = this.startDate(exhibition) + ', ' + this.startYear(exhibition);
      }
      return startDate + ' - ' + endDate;
    }
  },

  computed: {
    exhibitions: function exhibitions() {
      return this.loadedData[this.key];
    },

    year: function year() {
      return this.$route.params.year;
    },

    content: function content() {
      return this.exhibition.content;
    }
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_DataMixin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_ComponentMixin__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'generic-index',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_DataMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_ComponentMixin__["a" /* default */]],

  created: function created() {
    this.requestData(this.$route.name);
  },


  methods: {
    pageHero: function pageHero(name, files) {
      if (name.length > 0) {
        var file = files.find(function (item) {
          return item.filename === name;
        });
        return file.url;
      } else {
        return false;
      }
    },

    route: function route(uid) {
      var page = { name: this.$route.name + '-page', params: { id: uid } };
      var blog = { name: 'blog' };
      return uid === '600state' ? blog : page;
    }
  },

  computed: {
    title: function title() {
      return this.content.title.toLowerCase();
    },

    content: function content() {
      return this.loadedData[this.$route.name].content;
    },

    key: function key() {
      return this.$route.name;
    },

    files: function files() {
      return this.loadedData[this.$route.name].files;
    },

    children: function children() {
      return this.loadedData[this.$route.name].children;
    },

    hero: function hero() {
      var name = this.content.main_image;
      return this.files.find(function (item) {
        return item.filename === name;
      });
    },

    heroImage: function heroImage() {
      return this.hero.url;
    },


    heroAlt: function heroAlt() {
      return this.hero.meta.caption;
    },

    textColor: function textColor() {
      console.log(this.colors[this.category]);
      return 'color: ' + this.colors[this.$route.name];
    },

    backgroundColor: function backgroundColor() {
      return 'background-color: ' + this.colors[this.$route.name];
    }

  },

  watch: {
    '$route': function $route(to, from) {
      this.requestData(to.name);
    }
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_DataMixin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_ComponentMixin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_HomeEvents__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_HomeEvents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_home_HomeEvents__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home_HomeExplore__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home_HomeExplore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home_HomeExplore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_home_HomeExhibition__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_home_HomeExhibition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_home_HomeExhibition__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_DataMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_ComponentMixin__["a" /* default */]],

  components: {
    HomeEvents: __WEBPACK_IMPORTED_MODULE_2__components_home_HomeEvents___default.a,
    HomeExplore: __WEBPACK_IMPORTED_MODULE_3__components_home_HomeExplore___default.a,
    HomeExhibition: __WEBPACK_IMPORTED_MODULE_4__components_home_HomeExhibition___default.a
  },

  data: function data() {
    return {
      intro: window._caam_intro,
      introBG: window._caam_introBG,
      first: true,
      mainImage: {},
      ready: false,
      swiperOption: {
        notNextTick: true,
        autoplay: false,
        direction: 'horizontal',
        prevButton: '.swiper-button-prev',
        nextButton: '.swiper-button-next',
        mousewheelControl: false,
        observeParents: true,
        debugger: true
      }
    };
  },
  created: function created() {
    this.intro = window._caam_intro;
    this.introBG = window._caam_introBG;

    window._caam_whiteHeader = false;
    this.requestData('home', 'home');
    window.addEventListener('wheel', this.handleWheel);
    window.addEventListener('keydown', this.handleKey);

    document.title = 'CAAM | California African American Museum';
  },
  destroyed: function destroyed() {
    window.removeEventListener('wheel', this.handleWheel);
    window.removeEventListener('keydown', this.handleKey);
  },


  methods: {
    enter: function enter() {
      var _this = this;

      window._caam_intro = false;
      this.intro = window._caam_intro;

      setTimeout(function () {
        window._caam_introBG = false;
        _this.introBG = window._caam_introBG;
      }, 1020);
    },

    handleWheel: function handleWheel(e) {
      if (this.introBG) {}
      if (this.first && this.intro) {
        var debounce = true;
        if (e.deltaY > 0 && debounce) {
          this.enter();
          debounce = false;
        }
      }
    },
    handleKey: function handleKey(e) {
      if (this.introBG) {}
      if (this.first && this.intro) {
        var debounce = true;
        if (e.keyCode === 40 && debounce) {
          this.enter();
          debounce = false;
        }
        if (e.keyCode === 13 && debounce) {
          this.enter();
          debounce = false;
        }
      }
    },


    title: function title(exhibition) {
      return exhibition.content.title;
    }
  },

  computed: {
    exhibitionFirst: function exhibitionFirst() {
      var first = this.loadedData.home.exhibitions.splice(0, 1);
      return first[0];
    },

    exhibitions: function exhibitions() {
      return this.loadedData.home.exhibitions;
    },

    programs: function programs() {
      return this.loadedData.home.programs;
    },

    introImage: function introImage() {
      return this.loadedData.home.intro.mainImage;
    },

    explore: function explore() {
      return this.loadedData.home.intro.content.explore;
    },

    key: function key() {
      return 'home';
    }
  },

  watch: {
    $route: function $route() {
      this.intro = window._caam_intro;
      this.introBG = window._caam_introBG;
    }
  }
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_DataMixin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_ComponentMixin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_script2__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_script2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_script2__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'info-page',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_DataMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_ComponentMixin__["a" /* default */]],

  data: function data() {
    return {
      share: false,
      subpage: 'subid' in this.$route.params,
      swiperOption: {
        notNextTick: true,
        autoplay: false,
        direction: 'horizontal',
        prevButton: '.swiper-button-prev',
        nextButton: '.swiper-button-next',
        mousewheelControl: false,
        observeParents: true,
        debugger: false
      }
    };
  },
  created: function created() {
    this.requestData(this.key, 'info');
  },


  computed: {
    key: function key() {
      return this.$route.path.substring(1);
    },

    parent: function parent() {
      return this.loadedData[this.key].parent;
    },

    parentTitle: function parentTitle() {
      if (this.loadedData[this.key].parent_title) {
        return this.loadedData[this.key].parent_title;
      } else {
        return '';
      }
    },

    content: function content() {
      return this.loadedData[this.key].content;
    },

    files: function files() {
      return this.loadedData[this.key].files;
    },

    hero: function hero() {
      var name = this.content.main_image;
      return this.files.find(function (item) {
        return item.filename === name;
      });
    },

    isVisible: function isVisible() {
      return !this.loading ? this.loadedData[this.key].isVisible : true;
    },

    gallery: function gallery() {
      var _this = this;

      var names = this.content.gallery;
      var images = [];

      if (names.length > 0) {
        var nameArray = names.split(',');

        var _loop = function _loop() {
          var n = nameArray[i];
          images.push(_this.files.find(function (item) {
            return item.filename === n;
          }));
        };

        for (var i = 0; i < nameArray.length; i++) {
          _loop();
        }
        return images;
      } else {
        return false;
      }
    },

    url: function url() {
      if (this.hero) {
        return this.hero.url;
      }
    },

    heroMeta: function heroMeta() {
      if (!(Object.prototype.toString.call(this.hero.meta) === '[object Array]')) {
        return this.hero.meta;
      } else {
        return false;
      }
    },

    heroCaption: function heroCaption() {
      if (this.heroMeta) {
        return this.heroMeta.caption.length > 0 ? this.heroMeta.caption : false;
      }
    },

    heroCredit: function heroCredit() {
      if (this.heroMeta) {
        return this.heroMeta.credit.length > 0 ? this.heroMeta.credit : false;
      }
    },

    heroCaptions: function heroCaptions() {
      var cap = this.heroCaption;
      var cred = this.heroCredit;
      if (cap && cred) {
        return cap + '. ' + cred + '.';
      } else if (cap) {
        return cap + '.';
      } else if (cred) {
        return cred + '.';
      } else {
        return false;
      }
    },

    text: function text() {
      return this.content.text;
    },

    box: function box() {
      return this.content.box;
    },

    category: function category() {
      return this.key.split('/')[0];
    },

    children: function children() {
      return this.loadedData[this.key].children;
    },

    textColor: function textColor() {
      return 'color: ' + this.colors[this.category];
    },

    shareInfo: function shareInfo() {
      var data = {
        url: this.loadedData[this.key].url,
        title: this.title,
        description: this.text,
        image: this.hero.url
      };
      return data;
    }
  },

  updated: function updated() {
    __WEBPACK_IMPORTED_MODULE_2_vue_script2___default.a.load('https://assets.calendly.com/assets/external/widget.js').then(function () {
      if (Calendly.initInlineWidgets) {
        Calendly.initInlineWidgets();
      }
    });
  },

  watch: {
    $route: function $route(to) {
      this.subpage = 'subid' in to.params;
      this.requestData(this.key, 'info');
    },

    loading: function loading() {
      if (!this.isVisible && !this.loading) {
        this.$router.push('/404');
      }
    }
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_DataMixin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_ComponentMixin__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'programs',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_DataMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_ComponentMixin__["a" /* default */]],

  created: function created() {
    localStorage.clear();
    this.requestData('programs/' + this.$route.params.id, 'program');
    this.key = 'programs/' + this.$route.params.id;
  },
  data: function data() {
    return {
      share: false
    };
  },


  methods: {
    relatedExhibitionDate: function relatedExhibitionDate(ex) {
      var start = '';

      if (ex.content.start_year !== ex.content.end_year) {
        start = ex.content.start_date + ', ' + ex.content.start_year;
      } else {
        start = ex.content.start_date;
      }
      var end = ex.content.end_date + ', ' + ex.content.end_year;
      return start + ' - ' + end;
    },

    year: function year(exhibition) {
      return exhibition.content.start_year;
    },

    formatRoute: function formatRoute(item) {
      return item.replace(/ |'/g, '-').toLowerCase();
    },

    eventbriteCallback: function eventbriteCallback() {
      console.log('it worked!');
    },

    openEVWidget: function openEVWidget() {
      window.EBWidgets.createWidget({
        widgetType: 'checkout',
        eventId: this.eventbriteID,
        modal: true,
        modalTriggerElementId: 'eventbrite-widget-modal',
        onOrderComplete: this.eventbriteCallback
      });
    }
  },

  computed: {
    content: function content() {
      return this.loadedData[this.key].content;
    },

    category: function category() {
      return this.content.category;
    },

    eventbriteID: function eventbriteID() {
      return this.content.eventbrite_id;
    },

    eventbriteURL: function eventbriteURL() {
      return this.content.eventbrite;
    },

    title: function title() {
      return this.content.title;
    },

    virtual: function virtual() {
      return this.content.virtual === '1' ? ' virtual program' : false;
    },

    text: function text() {
      return this.content.text;
    },

    files: function files() {
      return this.loadedData[this.key].files;
    },

    date: function date() {
      return this.content.date;
    },

    startTime: function startTime() {
      return this.content.start_time;
    },

    endTime: function endTime() {
      return this.content.end_time;
    },

    locationName: function locationName() {
      return this.content.location_name;
    },

    location: function location() {
      return this.content.location;
    },

    locationAdd: function locationAdd() {
      return this.content.location_add;
    },

    rsvpLinkAllowed: function rsvpLinkAllowed() {
      if (this.eventbriteURL) {
        return this.eventbriteURL.length > 0;
      }
      return false;
    },

    rsvpIdAllowed: function rsvpIdAllowed() {
      if (this.eventbriteID) {
        return this.eventbriteID.length > 0;
      }
      return false;
    },

    related: function related() {
      if (this.loadedData[this.key].related) {
        return this.loadedData[this.key].related;
      }
      return [];
    },

    relatedExhibitions: function relatedExhibitions() {
      if (this.loadedData[this.key].related_exhibitions) {
        return this.loadedData[this.key].related_exhibitions;
      }
      return [];
    },

    hero: function hero() {
      var name = this.content.main_image;
      if (name.length > 0) {
        return this.files.find(function (item) {
          return item.filename === name;
        });
      } else {
        return false;
      }
    },

    heroMeta: function heroMeta() {
      if (!(Object.prototype.toString.call(this.hero.meta) === '[object Array]')) {
        return this.hero.meta;
      } else {
        return false;
      }
    },

    heroCaption: function heroCaption() {
      if (this.heroMeta) {
        return this.heroMeta.caption.length > 0 ? this.heroMeta.caption : false;
      }
    },

    heroCredit: function heroCredit() {
      if (this.heroMeta) {
        return this.heroMeta.credit.length > 0 ? this.heroMeta.credit : false;
      }
    },

    heroCaptions: function heroCaptions() {
      var cap = this.heroCaption;
      var cred = this.heroCredit;
      if (cap && cred) {
        return cap + '. ' + cred + '.';
      } else if (cap) {
        return cap + '.';
      } else if (cred) {
        return cred + '.';
      } else {
        return false;
      }
    },

    shareInfo: function shareInfo() {
      var data = {
        url: window.location.href,
        title: this.title,
        description: this.text,
        image: this.hero.url
      };
      return data;
    }
  },

  watch: {
    $route: function $route() {
      localStorage.clear();
      this.key = 'programs/' + this.$route.params.id;
      this.requestData(this.key, 'program');
      window.scrollTo(0, 0);
    }
  }
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_DataMixin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_ComponentMixin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_datepicker__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_datepicker__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'program',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_DataMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_ComponentMixin__["a" /* default */]],
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_datepicker___default.a
  },

  data: function data() {
    return {
      date: new Date(),
      selectDate: false,
      dateSelected: '',
      day: 'next 30 days',
      url: 'https://caamuseum.org/api/programs/day?date='
    };
  },
  created: function created() {
    this.requestData('programs', 'programs');
  },


  methods: {
    category: function category(item) {
      var str = item.split("'").join('-');
      var sanatize = str.split(' ').join('-').toLowerCase().split('!').join('');
      return sanatize.split(',').join('').toLowerCase();
    },

    openCalendar: function openCalendar() {
      document.getElementsByClassName('flatpickr-input')[0].focus();
    },

    closeCalendar: function closeCalendar() {
      document.getElementsByClassName('flatpickr-input')[0].blur();
    },

    update: function update() {
      this.getData();
    },

    getData: function getData() {
      var _this = this;

      var url = this.url + this.dateSelected;
      this.loading = true;
      this.get(url, function (response) {
        _this.loading = false;
        _this.week.splice(0, _this.week.length);
        _this.day = response.data.day;
        for (var i = 0; i < response.data.programs.length; i++) {
          _this.week.push(response.data.programs[i]);
        }
      });
    }
  },

  computed: {
    data: function data() {
      return this.loadedData.programs;
    },

    content: function content() {
      return this.data.content;
    },

    featured: function featured() {
      return this.data.featured;
    },

    featuredVirtual: function featuredVirtual() {
      return this.data.featured.content.virtual === '1' ? ' virtual program' : false;
    },

    past: function past() {
      return this.data.past;
    },

    edu: function edu() {
      return this.data.education;
    },

    week: function week() {
      return this.data.week;
    },

    children: function children() {
      return this.data.children;
    },

    key: function key() {
      return 'programs';
    }
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_DataMixin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_ComponentMixin__ = __webpack_require__(1);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'program',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_DataMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_ComponentMixin__["a" /* default */]],

  data: function data() {
    return {
      currentPagStart: 0,
      currentPagEnd: 10,
      loading: false,
      loadedData: [],

      url: '',
      offset: 0,
      limit: 10,
      currentIndex: 0
    };
  },
  created: function created() {
    this.url = 'https://caamuseum.org/api/programs/';
    this.getData();
  },


  methods: {
    getData: function getData() {
      var _this = this;

      var query = '?offset=' + this.offset + '&limit=' + this.limit;
      var url = this.url + this.rawCategory + query;
      this.loading = true;
      this.get(url, function (response) {
        _this.loading = false;
        _this.loadedData = response.data;
      });
    },

    loadPage: function loadPage(num) {
      this.currentIndex = num;
      this.offset = num * this.limit;
      this.getData();
      window.scrollTo(0, 0);
    },

    active: function active(num) {
      return num === this.currentIndex;
    },

    programCategory: function programCategory(item) {
      return item.content.category.split(' ').join('-').toLowerCase();
    },

    prevPage: function prevPage() {
      if (this.currentPagStart > 0) {
        this.currentPagStart--;
        this.currentPagEnd--;
        this.currentIndex--;
        this.loadPage(this.currentIndex);
      }
    },

    nextPage: function nextPage() {
      if (this.currentPagEnd < this.numPagesMax) {
        this.currentPagStart++;
        this.currentPagEnd++;
        this.currentIndex++;
        this.loadPage(this.currentIndex);
      }
    }
  },

  computed: {
    rawCategory: function rawCategory() {
      return this.$route.params.category;
    },

    data: function data() {
      return this.loadedData.programs;
    },

    category: function category() {
      return this.loadedData.category;
    },

    numPagesMax: function numPagesMax() {
      return Math.ceil(this.loadedData.total / 10);
    },

    numPagesTotal: function numPagesTotal() {
      return this.numPagesMax <= 1 ? [] : [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(Array(this.numPagesMax).keys()));
    },

    numPages: function numPages() {
      return this.numPagesTotal.slice(this.currentPagStart, this.currentPagEnd);
    },

    noEvents: function noEvents() {
      return this.loadedData.programs.length === 0;
    },

    categoryName: function categoryName() {
      var cat = this.category.toLowerCase();
      if (cat === 'kids teens and families') {
        return 'kids, teens and families';
      } else if (cat === 'all-past-events') {
        return 'all past events';
      } else if (cat === 'now') {
        return 'now!';
      } else if (cat === 'concerts performances and screenings') {
        return 'concerts, performances and screenings';
      } else if (cat === "can't stop won't stop") {
        return "can't stop, won't stop";
      } else {
        return cat;
      }
    }
  },

  watch: {
    $route: function $route() {
      this.getData();
    }
  }
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_DataMixin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_ComponentMixin__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'search',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_DataMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_ComponentMixin__["a" /* default */]],

  data: function data() {
    return {
      loading: false,
      loadedData: {},

      url: 'https://caamuseum.org/api/search?query='
    };
  },
  created: function created() {
    this.search();
  },


  computed: {
    query: function query() {
      return this.$route.query.query;
    },
    results: function results() {
      return this.loadedData.length > 0;
    },
    key: function key() {
      return 'search';
    }
  },

  methods: {
    search: function search() {
      var _this = this;

      var url = this.url + this.query;
      this.loading = true;
      this.get(url, function (response) {
        _this.loading = false;
        _this.loadedData = response.data;
      });
    },
    path: function path(item) {
      if (item.parent === 'programs') {
        var prefix = item.content.category.split(' ').join('-').toLowerCase();
        var path = 'programs/' + prefix + '/' + item.uid;
        return { path: path };
      } else if (item.parent === 'learn/600state') {
        var _prefix = void 0;
        if (item.content.category) {
          _prefix = item.content.category.split(' ').join('-').toLowerCase();
        } else {
          _prefix = 'black-history';
        }
        var _path = 'learn/600state/' + _prefix + '/' + item.uid;
        return { path: _path };
      } else {
        return { path: item.uri };
      }
    },
    text: function text(item) {
      return item.content.text;
    }
  },

  watch: {
    $route: function $route() {
      this.search();
    }
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_DataMixin__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'top-nav',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_DataMixin__["a" /* default */]],

  data: function data() {
    return {
      active: null,
      bannerLoaded: false,
      bannerText: '',
      menu: false,
      menuText: 'menu',
      query: null,
      search: false,
      searchOnly: false,
      whiteHeader: false
    };
  },


  props: ['headerColor'],

  created: function created() {
    this.requestData('root', 'root');
    this.getBannerData();

    this.whiteHeader = window._caam_whiteHeader;

    window._caam_menu = false;
    this.whiteHeader = this.headerColor === 'white';
  },


  computed: {
    ariaMenu: function ariaMenu() {
      return this.menuText === 'menu' ? 'open menu' : 'close menu';
    },
    activeElement: function activeElement() {
      return document.activeElement;
    },
    navElements: function navElements() {
      if (this.loadedData.root) {
        return this.loadedData.root.map(function (o) {
          if (o.uid === 'programs') {
            var newChildren = o.children.filter(function (c) {
              return c.uid !== 'Now!' && c.uid !== 'Special Events';
            });
            delete o.children;
            o.children = newChildren;
          }

          return o;
        });
      }
      return [];
    }
  },

  mounted: function mounted() {
    document.addEventListener('keyup', this.handleKeys);
  },
  destroyed: function destroyed() {
    document.removeEventListener('keyup', this.handleKeys);
  },


  methods: {
    getBannerData: function getBannerData() {
      var _this = this;

      this.bannerLoaded = false;
      this.get('https://caamuseum.org/api/banner', function (response) {
        _this.bannerLoaded = true;
        _this.bannerText = response.data[0];
      });
      this.bannerLoaded = true;
    },

    handleKeys: function handleKeys(e) {
      var classes = e.target.className;
      if (e.key === 'Tab') {
        if (classes === 'menu-button') {
          this.showNav();
        } else if (classes.includes('visit-link')) {
          this.showChildren('visit');
        } else if (classes.includes('exhibitions-link')) {
          this.showChildren('exhibitions');
        } else if (classes.includes('programs-link')) {
          this.showChildren('programs');
        } else if (classes.includes('collection-link')) {
          this.showChildren('collection');
        } else if (classes.includes('library-link')) {
          this.showChildren('library');
        } else if (classes.includes('learn-link')) {
          this.showChildren('learn');
        } else if (classes.includes('support-link')) {
          this.showChildren('support');
        } else if (classes.includes('about-link')) {
          this.showChildren('about');
        }
      }
    },
    showNav: function showNav() {
      this.menu = !window._caam_menu;
      this.menuText = this.menu ? 'close' : 'menu';
      this.searchOnly = false;
      this.search = false;

      window._caam_menu = this.menu;
    },
    showSearchOnly: function showSearchOnly() {
      if (!window._caam_menu) {
        this.showNav();
      }

      this.searchOnly = true;
      this.search = true;
    },
    showChildren: function showChildren(uid, event) {
      window._caam_active = uid;
      this.active = window._caam_active;
    },
    setHomeState: function setHomeState() {
      window._caam_introBG = false;
      window._caam_intro = false;
    },
    submit: function submit() {
      this.$router.push({ name: 'search', query: { query: this.query } });
    },
    subscribe: function subscribe() {
      this.$emit('update:subscribe', true);
    },
    searchIcon: function searchIcon() {
      return this.whiteHeader && this.menu || !this.whiteHeader && !this.menu;
    },
    formatRoute: function formatRoute(item) {
      return item.replace(/ |'/g, '-').toLowerCase().split('!').join('');
    },
    formatProgramChildren: function formatProgramChildren(item) {
      if (item === 'kids teens and families') {
        return 'kids, teens and families';
      } else if (item === "can't stop won't stop!") {
        return "can't stop, won't stop!";
      } else if (item === 'concerts performances and screenings') {
        return 'concerts, performances and screenings';
      } else {
        return item;
      }
    }
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home-events',

  props: ['programs'],

  methods: {
    programCategory: function programCategory(item) {
      return item.content.category.split(' ').join('-').toLowerCase();
    },

    title: function title(item) {
      var virtual = item.content.virtual === '1' ? ' | virtual program' : '';
      return item.content.title + virtual;
    }
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home-exhibition',

  props: ['exhibition'],

  computed: {
    startDate: function startDate() {
      return this.exhibition.content.start_date;
    },
    endDate: function endDate() {
      return this.exhibition.content.end_date;
    },
    startYear: function startYear() {
      return this.exhibition.content.start_year;
    },
    endYear: function endYear() {
      return this.exhibition.content.end_year;
    },
    displayDate: function displayDate() {
      var dd = this.exhibition.content.display_date;
      return !!dd ? dd : this.date;
    },
    date: function date() {
      var endDate = this.endDate + ', ' + this.endYear;
      var startDate = startDate = this.startDate;
      if (this.endYear !== this.startYear) {
        startDate = this.startDate + ', ' + this.startYear;
      }
      return startDate + ' - ' + endDate;
    },
    title: function title() {
      return this.exhibition.content.title;
    }
  }
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home-explore',

  props: ['explore'],

  data: function data() {
    return {
      swiperOption: {
        notNextTick: true,
        autoplay: false,
        direction: 'horizontal',
        prevButton: '.swiper-button-prev',
        nextButton: '.swiper-button-next',
        mousewheelControl: false,
        observeParents: true,
        debugger: true
      }
    };
  },


  computed: {
    swiper: function swiper() {
      return this.$refs.gallery.swiper;
    }
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'social',
  props: ['meta'],

  computed: {
    facebookUrl: function facebookUrl() {
      var url = 'https://www.facebook.com/sharer/sharer.php?';
      url += 'u=' + this.meta.url;
      url += '&title=' + this.meta.title;

      return url;
    },

    twitterUrl: function twitterUrl() {
      var url = 'https://twitter.com/intent/tweet?';
      url += 'url=' + this.meta.url;
      url += '&text=' + encodeURI(this.meta.title);
      return url;
    },

    emailUrl: function emailUrl() {
      var url = 'mailto:?subject=CAAM: ' + this.meta.title;
      url += '&body=' + this.meta.url;
      return url;
    }
  }
});

/***/ }),
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 163 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 164 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 167 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 170 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 171 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 173 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 174 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 175 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 176 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 177 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 178 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 179 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 180 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(170)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(229),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(172)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(96),
  /* template */
  __webpack_require__(234),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(175)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(97),
  /* template */
  __webpack_require__(237),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(166)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(225),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(163)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(99),
  /* template */
  __webpack_require__(222),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(180)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(100),
  /* template */
  __webpack_require__(242),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(232),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(177)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(102),
  /* template */
  __webpack_require__(239),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(174)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(103),
  /* template */
  __webpack_require__(236),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(179)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(241),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(183)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(105),
  /* template */
  __webpack_require__(246),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(178)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(106),
  /* template */
  __webpack_require__(240),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(176)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(238),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(182)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(108),
  /* template */
  __webpack_require__(245),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(162)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(109),
  /* template */
  __webpack_require__(221),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(168)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(227),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(173)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(111),
  /* template */
  __webpack_require__(235),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(184)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(112),
  /* template */
  __webpack_require__(247),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(164)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(223),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(167)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(114),
  /* template */
  __webpack_require__(226),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(169)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(115),
  /* template */
  __webpack_require__(228),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(171)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(231),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(185)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(117),
  /* template */
  __webpack_require__(248),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(233),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(230),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(90),
  /* template */
  __webpack_require__(243),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(91),
  /* template */
  __webpack_require__(250),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(186)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(249),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(165)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(93),
  /* template */
  __webpack_require__(224),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 221 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('top-nav', {
    attrs: {
      "headerColor": "white"
    }
  }), (_vm.loading) ? _c('div', {
    staticClass: "placeholder"
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "content program"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-4_xs-12 titles"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'programs'
      }
    }
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v("programs")])]), _c('router-link', {
    attrs: {
      "to": {
        name: 'programs-overview',
        params: {
          category: _vm.formatRoute(_vm.category)
        }
      }
    }
  }, [_c('h4', {
    staticClass: "category h-sm"
  }, [_vm._v(_vm._s(_vm.category))])]), _c('h1', {
    staticClass: "h-xl"
  }, [_vm._v(_vm._s(_vm.title))]), _c('h4', {
    staticClass: "h-sm"
  }, [_vm._v(_vm._s(_vm.date))]), _c('h4', {
    staticClass: "h-sm"
  }, [_vm._v(_vm._s(_vm.startTime) + " - " + _vm._s(_vm.endTime))]), _c('div', {
    staticClass: "location"
  }, [_c('h4', {
    staticClass: "h-sm"
  }, [_vm._v(_vm._s(_vm.locationName))]), _c('h4', {
    staticClass: "h-sm"
  }, [_vm._v(_vm._s(_vm.location))]), _c('h4', {
    staticClass: "h-sm"
  }, [_vm._v(_vm._s(_vm.locationAdd))]), (_vm.virtual) ? _c('h4', {
    staticClass: "h-sm"
  }, [_vm._v(_vm._s(_vm.virtual))]) : _vm._e()]), _c('h4', {
    staticClass: "share h-sm",
    on: {
      "click": function($event) {
        _vm.share = !_vm.share
      }
    }
  }, [_vm._v("share"), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.share) ? _c('social', {
    attrs: {
      "meta": _vm.shareInfo
    }
  }) : _vm._e()], 1)], 1)], 1), _c('div', {
    staticClass: "col-8_xs-12"
  }, [_c('div', {
    staticClass: "hero"
  }, [(_vm.hero.url) ? _c('img', {
    staticClass: "cover",
    attrs: {
      "src": _vm.hero.url,
      "alt": _vm.heroCaptions
    }
  }) : _vm._e()]), (_vm.heroCaptions) ? _c('div', {
    staticClass: "captions-hero"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.heroCaptions)
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "copy grid no-margin",
    class: {
      noimage: !_vm.hero.url
    }
  }, [_c('div', {
    staticClass: "col-7_xs-12 wysiwyg",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), (_vm.rsvpIdAllowed) ? _c('div', {
    staticClass: "col-3_xs-12",
    on: {
      "click": _vm.openEVWidget
    }
  }, [_c('h4', {
    staticClass: "rsvp h-sm",
    attrs: {
      "id": "eventbrite-widget-modal"
    }
  }, [_vm._v("rsvp for this event")])]) : _vm._e(), (_vm.rsvpLinkAllowed) ? _c('div', {
    staticClass: "col-3_xs-12"
  }, [_c('a', {
    attrs: {
      "href": _vm.eventbriteURL,
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "rsvp"
  }, [_c('h4', {
    staticClass: "h-sm"
  }, [_vm._v("rsvp for this event")])])])]) : _vm._e()])]), (_vm.related.length > 0) ? _c('div', {
    staticClass: "col-4_xs-12 related"
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v("related programs")])]) : _vm._e(), (_vm.related.length > 0) ? _c('div', {
    staticClass: "col-8_xs-12 related"
  }, [_c('div', {
    staticClass: "grid no-margin"
  }, _vm._l((_vm.related), function(program) {
    return _c('div', {
      staticClass: "col-5_xs-12 details",
      attrs: {
        "data-push-right": "off-1"
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'programs-page',
          params: {
            category: 'current',
            id: program.uid
          }
        }
      }
    }, [_c('h3', {
      staticClass: "h-m"
    }, [_vm._v(_vm._s(program.title))]), _c('h4', {
      staticClass: "h-sm"
    }, [_vm._v(_vm._s(program.content.date))]), _c('p', {
      staticClass: "h-sxx"
    }, [_vm._v(_vm._s(program.content.start_time) + " - " + _vm._s(program.content.end_time))]), _c('div', {
      staticClass: "col-4 related"
    })])], 1)
  }))]) : _vm._e(), (_vm.relatedExhibitions.length > 0) ? _c('div', {
    staticClass: "col-4_xs-12 related"
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v("related exhibitions")])]) : _vm._e(), (_vm.relatedExhibitions.length > 0) ? _c('div', {
    staticClass: "col-8_xs-12 related"
  }, [_c('div', {
    staticClass: "grid no-margin"
  }, _vm._l((_vm.relatedExhibitions), function(exhibition) {
    return _c('div', {
      staticClass: "col-5_xs-12 details",
      attrs: {
        "data-push-right": "off-1"
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'exhibition-single',
          params: {
            year: _vm.year(exhibition),
            id: exhibition.uid
          }
        }
      }
    }, [_c('h3', {
      staticClass: "h-m"
    }, [_vm._v(_vm._s(exhibition.content.title))]), _c('h4', {
      staticClass: "h-sm"
    }, [_vm._v(_vm._s(exhibition.content.teaser))]), _c('p', {
      staticClass: "h-sxx"
    }, [_vm._v(_vm._s(_vm.relatedExhibitionDate(exhibition)))]), _c('div', {
      staticClass: "col-4 related"
    })])], 1)
  }))]) : _vm._e()])]) : _vm._e()]), _c('bottom-nav', {
    attrs: {
      "footerColor": "white"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 222 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.galleryFS) ? _c('div', {
    staticClass: "fullscreen"
  }, [_c('div', {
    staticClass: "gallery-captions"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.galleryCaption.caption)
    }
  }), _c('p', [_vm._v(_vm._s(_vm.galleryCaption.credit))])]), _c('swiper', {
    ref: "fullscreen-gallery",
    staticClass: "gallery exhibition",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.gallery), function(image) {
    return (!_vm.loading) ? _c('swiper-slide', {
      key: image.title
    }, [_c('div', {
      staticClass: "slide"
    }, [_c('img', {
      staticClass: "cover",
      attrs: {
        "src": image.url,
        "alt": image.caption
      }
    })])]) : _vm._e()
  })), _c('div', {
    staticClass: "swiper-button-prev",
    attrs: {
      "aria-label": "Previous Slide"
    },
    slot: "button-prev"
  }), _c('div', {
    staticClass: "swiper-button-next",
    attrs: {
      "aria-label": "Next Slide"
    },
    slot: "button-next"
  }), _c('div', {
    staticClass: "index"
  }, [_c('p', [_vm._v(_vm._s(_vm.galleryIndex) + " of " + _vm._s(_vm.numGalleryItems))])]), _c('div', {
    staticClass: "less",
    on: {
      "click": _vm.fullscreen
    }
  }, [_c('visual', {
    attrs: {
      "image": "/static/icons/x_out.svg"
    }
  })], 1)], 1) : _vm._e()]), _c('top-nav', {
    attrs: {
      "headerColor": "white"
    }
  }), (_vm.loading) ? _c('div', {
    staticClass: "placeholder"
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.loading && !_vm.galleryFS) ? _c('div', {
    staticClass: "content exhibition"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-4_xs-12 titles"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'exhibitions'
      }
    }
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v("exhibitions")])]), _c('h4', {
    staticClass: "status h-sm"
  }, [_vm._v(_vm._s(_vm.status))]), _c('div', {
    staticClass: "title-details"
  }, [_c('h1', {
    staticClass: "h-xl"
  }, [_vm._v(_vm._s(_vm.title))]), _c('h3', {
    staticClass: "h-sm teaser"
  }, [_vm._v(_vm._s(_vm.teaser))]), _c('h4', {
    staticClass: "h-sm"
  }, [_vm._v(_vm._s(_vm.displayDate))]), (_vm.curator) ? _c('h4', {
    staticClass: "h-sm curator"
  }, [_vm._v("curated by: " + _vm._s(_vm.curator))]) : _vm._e(), _c('h4', {
    staticClass: "h-sm share",
    on: {
      "click": function($event) {
        _vm.share = !_vm.share
      }
    }
  }, [_vm._v("share")]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.share) ? _c('social', {
    attrs: {
      "meta": _vm.shareInfo
    }
  }) : _vm._e()], 1)], 1)], 1), _c('div', {
    staticClass: "col-8_xs-12 hero-image"
  }, [_c('div', {
    staticClass: "hero"
  }, [(_vm.hero) ? _c('img', {
    staticClass: "cover",
    attrs: {
      "src": _vm.hero.url,
      "alt": _vm.captions
    }
  }) : _vm._e()]), (_vm.captions) ? _c('p', {
    staticClass: "heroCaptions body-captions",
    domProps: {
      "innerHTML": _vm._s(_vm.captions)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "title-details-mobile"
  }, [_c('h1', {
    staticClass: "h-xl"
  }, [_vm._v(_vm._s(_vm.title))]), _c('h3', {
    staticClass: "teaser h-sm"
  }, [_vm._v(_vm._s(_vm.teaser))]), _c('h4', {
    staticClass: "h-sm"
  }, [_vm._v(_vm._s(_vm.displayDate))])]), _c('div', {
    staticClass: "grid no-margin copy"
  }, [_c('div', {
    staticClass: "col-9_xs-12 wysiwyg",
    class: {
      noimage: !_vm.hero.url
    },
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  })])]), (_vm.gallery.length > 0) ? _c('div', {
    staticClass: "col-4_xs-12 preview"
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v("exhibition preview")])]) : _vm._e(), (_vm.gallery.length > 0) ? _c('div', {
    staticClass: "col-8_xs-12 preview"
  }, [_c('div', {
    staticClass: "more"
  }, [_c('div', {
    staticClass: "icon",
    on: {
      "click": _vm.fullscreen
    }
  }, [_c('visual', {
    attrs: {
      "image": "/static/icons/plus_black.svg"
    }
  })], 1)]), _c('swiper', {
    ref: "gallery",
    staticClass: "gallery",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.gallery), function(image) {
    return _c('swiper-slide', {
      key: image.title
    }, [_c('div', {
      staticClass: "slide"
    }, [_c('img', {
      staticClass: "cover",
      attrs: {
        "src": image.url,
        "alt": image.meta.caption
      }
    })])])
  }), _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }), _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  })], 2), _c('div', {
    staticClass: "index"
  }, [_c('p', [_vm._v(_vm._s(_vm.galleryIndex) + " of " + _vm._s(_vm.numGalleryItems))])])], 1) : _vm._e(), (_vm.relatedPrograms.length > 0) ? _c('div', {
    staticClass: "col-4_xs-12 programs"
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v("related programs")])]) : _vm._e(), (_vm.relatedPrograms.length > 0) ? _c('div', {
    staticClass: "col-8_xs-12 programs details"
  }, [_c('div', {
    staticClass: "grid no-margin"
  }, _vm._l((_vm.relatedPrograms), function(program) {
    return _c('div', {
      staticClass: "col-5",
      staticStyle: {
        "padding-left": "2.6rem"
      },
      attrs: {
        "data-push-right": "off-1"
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'programs-page',
          params: {
            category: 'current',
            id: program.uid
          }
        }
      }
    }, [_c('h3', {
      staticClass: "h-m"
    }, [_vm._v(_vm._s(program.title))]), _c('h4', {
      staticClass: "h-sm"
    }, [_vm._v(_vm._s(program.content.date))]), _c('p', {
      staticClass: "h-sxx"
    }, [_vm._v(_vm._s(program.content.start_time) + " - " + _vm._s(program.content.end_time))])])], 1)
  }))]) : _vm._e(), (_vm.relatedArticles.length > 0) ? _c('div', {
    staticClass: "col-4_xs-12 related"
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v("related articles")])]) : _vm._e(), (_vm.relatedArticles.length > 0) ? _c('div', {
    staticClass: "col-8_xs-12 related"
  }, [_c('div', {
    staticClass: "grid no-margin"
  }, _vm._l((_vm.relatedArticles), function(article) {
    return _c('div', {
      staticClass: "col-5_xs-12 details",
      staticStyle: {
        "padding-left": "2.6rem"
      },
      attrs: {
        "data-push-right": "off-1"
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'article',
          params: {
            article: article.uid
          }
        }
      }
    }, [_c('h3', {
      staticClass: "h-m",
      domProps: {
        "innerHTML": _vm._s(_vm.checkTitle(article))
      }
    }), _c('h4', {
      staticClass: "h-sm"
    }, [_vm._v(_vm._s(article.content.teaser))]), _c('div', {
      staticClass: "col-4 related"
    })])], 1)
  }))]) : _vm._e(), (_vm.press.length > 0) ? _c('div', {
    staticClass: "col-4_xs-12 press"
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v("in the news")])]) : _vm._e(), (_vm.press.length > 0) ? _c('div', {
    staticClass: "col-8_xs-12 press"
  }, [_c('div', {
    staticClass: "grid no-margin"
  }, _vm._l((_vm.press), function(article) {
    return _c('div', {
      staticClass: "col-5",
      staticStyle: {
        "padding-left": "2.6rem"
      },
      attrs: {
        "data-push-right": "off-1"
      }
    }, [_c('a', {
      attrs: {
        "href": article.link,
        "target": "_blank"
      }
    }, [_c('h3', {
      staticClass: "h-m"
    }, [_vm._v(_vm._s(article.teaser))]), _c('h4', {
      staticClass: "h-sm"
    }, [_vm._v(_vm._s(_vm.articleDate(article.date)))]), _c('p', {
      staticClass: "h-sxx"
    }, [_vm._v("- " + _vm._s(article.publication))])])])
  }))]) : _vm._e(), (_vm.resources.length > 0) ? _c('div', {
    staticClass: "col-4_xs-12 resources"
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v("resources")])]) : _vm._e(), (_vm.resources.length > 0) ? _c('div', {
    staticClass: "col-8_xs-12 resources"
  }, [_c('div', {
    staticClass: "grid no-margin"
  }, _vm._l((_vm.resources), function(resource) {
    return _c('div', {
      staticClass: "col-5_xs-12",
      staticStyle: {
        "padding-left": "2.6rem"
      },
      attrs: {
        "data-push-right": "off-1_xs-0"
      }
    }, [_c('a', {
      attrs: {
        "href": resource.link,
        "target": "_blank"
      }
    }, [_c('h3', {
      staticClass: "h-m"
    }, [_vm._v(_vm._s(resource.title))])])])
  }))]) : _vm._e()])]) : _vm._e()]), (!_vm.galleryFS) ? _c('bottom-nav', {
    attrs: {
      "footerColor": "white"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 223 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    class: {
      white: _vm.whiteHeader
    },
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "grid-noBottom"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('router-link', {
    staticClass: "home",
    attrs: {
      "to": {
        name: 'home'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.setHomeState($event)
      }
    }
  }, [_c('h2', {
    staticClass: "h-l lh-8"
  }, [_vm._v("California "), _c('br'), _vm._v("\nAfrican American "), _c('br'), _vm._v("\nMuseum")]), _c('div', {
    staticClass: "header-logo"
  }, [(!_vm.whiteHeader) ? _c('visual', {
    attrs: {
      "image": "/static/logos/caam_logo_white.svg"
    }
  }) : _vm._e(), (_vm.whiteHeader) ? _c('visual', {
    attrs: {
      "image": "/static/logos/caam_logo.svg"
    }
  }) : _vm._e()], 1)])], 1)]), _c('nav', [_c('button', {
    staticClass: "h-l ag bold menu-button",
    class: {
      active: _vm.menu, white: _vm.whiteHeader
    },
    attrs: {
      "aria-label": _vm.ariaMenu
    },
    on: {
      "click": _vm.showNav
    }
  }, [_vm._v(_vm._s(_vm.menuText))]), (!_vm.menu) ? _c('div', {
    staticClass: "hamburger",
    class: {
      active: _vm.menu
    },
    on: {
      "click": _vm.showNav
    }
  }, [(!_vm.whiteHeader) ? _c('visual', {
    attrs: {
      "image": "/static/icons/hamburger.svg"
    }
  }) : _vm._e(), (_vm.whiteHeader) ? _c('visual', {
    attrs: {
      "image": "/static/icons/hamburger_black.svg"
    }
  }) : _vm._e()], 1) : _vm._e(), (_vm.menu) ? _c('div', {
    staticClass: "x",
    class: {
      active: _vm.menu
    },
    on: {
      "click": _vm.showNav
    }
  }, [(_vm.whiteHeader) ? _c('visual', {
    attrs: {
      "image": "/static/icons/x_out_white.svg"
    }
  }) : _vm._e(), (!_vm.whiteHeader) ? _c('visual', {
    attrs: {
      "image": "/static/icons/x_out_black.svg"
    }
  }) : _vm._e()], 1) : _vm._e(), (_vm.searchIcon()) ? _c('button', {
    staticClass: "icon",
    attrs: {
      "aria-label": "Open search by pressing enter or clicking.",
      "role": "button"
    },
    on: {
      "click": _vm.showSearchOnly
    }
  }, [_c('visual', {
    attrs: {
      "image": "/static/icons/search_white.svg",
      "width": "3rem"
    }
  })], 1) : _vm._e(), (!_vm.searchIcon()) ? _c('button', {
    staticClass: "icon",
    attrs: {
      "href": "",
      "aria-label": "open search",
      "role": "button"
    },
    on: {
      "click": _vm.showSearchOnly
    }
  }, [_c('visual', {
    attrs: {
      "image": "/static/icons/search_black.svg",
      "width": "3rem"
    }
  })], 1) : _vm._e(), (!_vm.loading) ? _c('ul', {
    class: {
      active: _vm.menu, white: !_vm.whiteHeader, black: _vm.whiteHeader
    }
  }, [_vm._l((_vm.navElements), function(item) {
    return (!_vm.searchOnly) ? _c('li', [_c('router-link', {
      staticClass: "bold l-l",
      class: item.uid + '-link',
      attrs: {
        "to": {
          name: item.uid
        }
      },
      nativeOn: {
        "mouseover": function($event) {
          _vm.showChildren(item.uid, $event)
        }
      }
    }, [_vm._v(_vm._s(item.title))]), (_vm.active === item.uid) ? _c('ul', {
      staticClass: "d-o"
    }, _vm._l((item.children), function(child) {
      return _c('li', [((item.uid !== 'exhibitions' && item.uid !== 'programs' && item.uid !== 'learn' && item.uid !== 'about')) ? _c('router-link', {
        staticClass: "bold l-sm",
        attrs: {
          "to": {
            name: ((item.uid) + "-page"),
            params: {
              id: _vm.formatRoute(child.uid)
            }
          }
        }
      }, [_vm._v(_vm._s(child.title.toLowerCase()))]) : _vm._e(), (item.uid === 'exhibitions' && _vm.formatRoute(child.uid) !== 'current') ? _c('router-link', {
        staticClass: "bold l-sm",
        attrs: {
          "to": {
            name: ((item.uid) + "-overview"),
            params: {
              year: _vm.formatRoute(child.uid)
            }
          }
        }
      }, [_vm._v(_vm._s(child.title.toLowerCase()))]) : _vm._e(), (item.uid === 'exhibitions' && _vm.formatRoute(child.uid) === 'current') ? _c('router-link', {
        staticClass: "bold l-sm",
        attrs: {
          "to": {
            name: ("" + (item.uid))
          }
        }
      }, [_vm._v(_vm._s(child.title.toLowerCase()))]) : _vm._e(), (item.uid === 'programs') ? _c('router-link', {
        staticClass: "bold l-sm",
        attrs: {
          "to": {
            name: ((item.uid) + "-overview"),
            params: {
              category: _vm.formatRoute(child.uid)
            }
          }
        }
      }, [_vm._v(_vm._s(_vm.formatProgramChildren(child.title.toLowerCase())))]) : _vm._e(), (item.uid === 'learn' && child.uid === '600state') ? _c('router-link', {
        staticClass: "bold l-sm",
        attrs: {
          "to": {
            name: 'blog'
          }
        }
      }, [_vm._v(_vm._s(child.title.toLowerCase()))]) : (item.uid === 'learn' && child.uid !== '600state') ? _c('router-link', {
        staticClass: "bold l-sm",
        attrs: {
          "to": {
            name: ((item.uid) + "-page"),
            params: {
              id: _vm.formatRoute(child.uid)
            }
          }
        }
      }, [_vm._v(_vm._s(child.title.toLowerCase()))]) : ((item.uid === 'about' && child.uid !== 'subscribe')) ? _c('router-link', {
        staticClass: "bold l-sm",
        attrs: {
          "to": {
            name: ((item.uid) + "-page"),
            params: {
              id: _vm.formatRoute(child.uid)
            }
          }
        }
      }, [_vm._v(_vm._s(child.title.toLowerCase()))]) : ((item.uid === 'about' && child.uid === 'subscribe')) ? _c('h3', {
        on: {
          "click": _vm.subscribe
        }
      }, [_vm._v(_vm._s(child.title.toLowerCase()))]) : _vm._e()], 1)
    })) : _vm._e()], 1) : _vm._e()
  }), _c('li', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.search) ? _c('ul', {
    staticClass: "search",
    class: {
      black: _vm.whiteHeader
    }
  }, [_c('li', [_c('form', {
    attrs: {
      "onsubmit": "return false"
    }
  }, [_c('label', {
    staticClass: "dn",
    attrs: {
      "for": "searchterm"
    }
  }, [_vm._v("Search Query")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    attrs: {
      "type": "text",
      "name": "searchterm",
      "title": "Search Query"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  })])]), _c('li', [_c('h4', {
    attrs: {
      "role": "button",
      "aria-label": "Submit search."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("just ask.")])])]) : _vm._e()])], 1)], 2) : _vm._e()]), (_vm.bannerLoaded) ? _c('div', {
    staticClass: "banner"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.bannerText)
    }
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 224 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "__cov-progress",
    style: (_vm.style)
  })
},staticRenderFns: []}

/***/ }),
/* 225 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error"
  }, [_c('top-nav', {
    attrs: {
      "headerColor": "white"
    }
  }), _vm._m(0), _c('bottom-nav', {
    attrs: {
      "footerColor": "white"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-3_xs-12"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h1', {
    staticClass: "h-xl"
  }, [_vm._v("Sorry, we couldn't find the page you were looking for!")]), _c('h2', {
    staticClass: "h-sm bold"
  }, [_vm._v("Error code: 404 "), _c('br')])])]), _c('div', {
    staticClass: "col-9_xs-12"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": "/static/images/404_image.jpg",
      "alt": "page not found 404"
    }
  }), _c('p', {
    staticClass: "message body"
  }, [_vm._v("You can go back to the page that brought you here, or you can look for the page you want using our site search.")])])])])
}]}

/***/ }),
/* 226 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "events"
  }, [_c('h2', {
    staticClass: "h-l event-title"
  }, [_vm._v("upcoming programs")]), _c('div', {
    staticClass: "eventsContainer"
  }, _vm._l((_vm.programs), function(program) {
    return _c('div', {
      staticClass: "preview"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'programs-page',
          params: {
            category: _vm.programCategory(program),
            id: program.uid
          }
        }
      }
    }, [_c('div', {
      staticClass: "events-hero"
    }, [_c('img', {
      staticClass: "cover",
      attrs: {
        "src": program.mainImage,
        "alt": program.content.title
      }
    })]), _c('div', {
      staticClass: "eventCaptions"
    }, [_c('h2', {
      staticClass: "h-m"
    }, [_vm._v(_vm._s(_vm.title(program)))]), _c('div', {
      staticClass: "dateTime"
    }, [_c('h3', {
      staticClass: "h-sm"
    }, [_vm._v(_vm._s(program.content.date))]), _c('p', {
      staticClass: "h-sxx"
    }, [_vm._v(_vm._s(program.content.start_time) + " - " + _vm._s(program.content.end_time))])])])])], 1)
  }))])
},staticRenderFns: []}

/***/ }),
/* 227 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('top-nav', {
    attrs: {
      "headerColor": "white"
    }
  }), (_vm.loading) ? _c('div', {
    staticClass: "placeholder"
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "content programs"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h1', {
    staticClass: "h-l category"
  }, [_vm._v("programs")])]), _c('div', {
    staticClass: "col-12"
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "screen"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'programs-page',
        params: {
          category: _vm.category(_vm.featured.content.category),
          id: _vm.featured.uid
        }
      }
    }
  }, [_c('div', {
    staticClass: "hero"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": _vm.featured.main_image.url,
      "alt": "CAAM Programs"
    }
  })]), _c('div', {
    staticClass: "captions gradient"
  }, [_c('h2', {
    staticClass: "h-xl"
  }, [_vm._v(_vm._s(_vm.featured.title))]), _c('h2', {
    staticClass: "h-l"
  }, [_vm._v(_vm._s(_vm.featured.content.date))]), _c('h2', {
    staticClass: "h-l"
  }, [_vm._v(_vm._s(_vm.featured.content.start_time) + " - " + _vm._s(_vm.featured.content.end_time))]), (_vm.featuredVirtual) ? _c('h2', {
    staticClass: "h-l"
  }, [_vm._v(_vm._s(_vm.featuredVirtual))]) : _vm._e()])])], 1) : _vm._e()]), _c('div', {
    staticClass: "col-4_xs-12 titles"
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v("calendar")])]), _c('div', {
    staticClass: "col-8_xs-12 week",
    attrs: {
      "id": "calendarcontainer"
    }
  }, [_c('div', {
    staticClass: "grid no-margin"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v(_vm._s(_vm.day))])]), _vm._l((_vm.week), function(program) {
    return (_vm.week.length > 0) ? _c('div', {
      staticClass: "col-8"
    }, [_c('router-link', {
      staticClass: "dateTime",
      attrs: {
        "to": {
          name: 'programs-page',
          params: {
            category: _vm.category(program.content.category),
            id: program.uid
          }
        }
      }
    }, [_c('h3', {
      staticClass: "h-m"
    }, [_vm._v(_vm._s(program.content.title))]), _c('h4', {
      staticClass: "h-sm"
    }, [_vm._v(_vm._s(program.content.date))]), _c('p', {
      staticClass: "h-sxx"
    }, [_vm._v(_vm._s(program.content.start_time) + " - " + _vm._s(program.content.end_time))])])], 1) : _vm._e()
  }), (_vm.week.length === 0) ? _c('div', {
    staticClass: "col-8"
  }, [_c('h4', {
    staticClass: "h-l"
  }, [_vm._v("No events scheduled for this day.")])]) : _vm._e(), _c('div', {
    staticClass: "col-8"
  }, [_c('div', {
    staticClass: "pmargin"
  })]), _vm._l((_vm.children), function(item) {
    return _c('div', {
      staticClass: "col-6_xs-12"
    }, [_c('div', {
      staticClass: "filter"
    }, [_c('div', {
      staticClass: "captions-mobile"
    }, [_c('h2', {
      staticClass: "h-l subpage"
    }, [_vm._v(_vm._s(item.category.toLowerCase()))])]), (!_vm.loading) ? _c('div', {
      staticClass: "screen-smaller"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'programs-overview',
          params: {
            category: _vm.category(item.category)
          }
        }
      }
    }, [_c('img', {
      staticClass: "cover",
      attrs: {
        "src": item.main_image.url
      }
    })]), _c('div', {
      staticClass: "captions gradient"
    }, [_c('h2', {
      staticClass: "h-l subpage"
    }, [_vm._v(_vm._s(item.category.toLowerCase()))])])], 1) : _vm._e()])])
  })], 2)])])]) : _vm._e()]), _c('bottom-nav', {
    attrs: {
      "footerColor": "white"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 228 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "screen"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'exhibition-single',
        params: {
          year: _vm.startYear,
          id: _vm.exhibition.uid
        }
      }
    }
  }, [_c('div', {
    staticClass: "preview-home"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": _vm.exhibition.mainImage,
      "alt": _vm.exhibition.title
    }
  }), _c('div', {
    staticClass: "captions"
  }, [_c('h2', {
    staticClass: "h-xl ex-title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('h4', {
    staticClass: "h-l"
  }, [_vm._v(_vm._s(_vm.displayDate))])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 229 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('top-nav', {
    attrs: {
      "headerColor": "white"
    }
  }), (_vm.loading) ? _c('div', {
    staticClass: "placeholder"
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "content article"
  }, [_c('div', {
    staticClass: "grid margin-top-12"
  }, [_c('div', {
    staticClass: "col-4_xs-12 titles"
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v("learn")]), _c('router-link', {
    attrs: {
      "to": {
        name: 'blog'
      }
    }
  }, [_c('h3', {
    staticClass: "h-sm category"
  }, [_vm._v("600state")])]), _c('h1', {
    staticClass: "h-xl",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _c('div', {
    staticClass: "author-date"
  }, [_c('h4', {
    staticClass: "h-md author"
  }, [_vm._v(_vm._s(_vm.author))]), _c('h4', {
    staticClass: "h-md date"
  }, [_vm._v(_vm._s(_vm.date))])]), _c('h4', {
    staticClass: "h-sm share",
    on: {
      "click": function($event) {
        _vm.share = !_vm.share
      }
    }
  }, [_vm._v("share"), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.share) ? _c('social', {
    attrs: {
      "meta": _vm.shareInfo
    }
  }) : _vm._e()], 1)], 1)], 1), _c('div', {
    staticClass: "col-8_xs-12"
  }, [_c('div', {
    staticClass: "hero"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": _vm.hero.url,
      "alt": _vm.heroCaption
    }
  })]), (_vm.captions) ? _c('p', {
    staticClass: "heroCaptions body-captions",
    domProps: {
      "innerHTML": _vm._s(_vm.captions)
    }
  }) : _vm._e()]), (_vm.hero.url) ? _c('div', {
    staticClass: "col-5_xs-12",
    attrs: {
      "data-push-left": "off-4_xs-0"
    }
  }, [_c('div', {
    staticClass: "copy wysiwyg",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  })]) : _vm._e(), (_vm.relatedExhibitions.length > 0) ? _c('div', {
    staticClass: "col-4_xs-12 related"
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v("related exhibitions")])]) : _vm._e(), (_vm.relatedExhibitions.length > 0) ? _c('div', {
    staticClass: "col-8_xs-12 related"
  }, [_c('div', {
    staticClass: "grid no-margin"
  }, _vm._l((_vm.relatedExhibitions), function(exhibition) {
    return _c('div', {
      staticClass: "col-5_xs-12 details",
      attrs: {
        "data-push-right": "off-1"
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'exhibition-single',
          params: {
            year: _vm.year(exhibition),
            id: exhibition.uid
          }
        }
      }
    }, [_c('h3', {
      staticClass: "h-m"
    }, [_vm._v(_vm._s(exhibition.content.title))]), _c('h4', {
      staticClass: "h-sm"
    }, [_vm._v(_vm._s(exhibition.content.teaser))]), _c('p', {
      staticClass: "h-sxx"
    }, [_vm._v(_vm._s(_vm.relatedExhibitionDate(exhibition)))]), _c('div', {
      staticClass: "col-4 related"
    })])], 1)
  }))]) : _vm._e(), (_vm.relatedArticles.length > 0) ? _c('div', {
    staticClass: "col-4_xs-12 related"
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v("related articles")])]) : _vm._e(), (_vm.relatedArticles.length > 0) ? _c('div', {
    staticClass: "col-8_xs-12 related"
  }, [_c('div', {
    staticClass: "grid no-margin"
  }, _vm._l((_vm.relatedArticles), function(article) {
    return _c('div', {
      staticClass: "col-5_xs-12 details",
      attrs: {
        "data-push-right": "off-1"
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'article',
          params: {
            article: article.uid
          }
        }
      }
    }, [_c('h3', {
      staticClass: "h-m",
      domProps: {
        "innerHTML": _vm._s(_vm.checkTitle(article))
      }
    }), _c('h4', {
      staticClass: "h-sm"
    }, [_vm._v(_vm._s(article.content.teaser))]), _c('div', {
      staticClass: "col-4 related"
    })])], 1)
  }))]) : _vm._e()])]) : _vm._e()]), _c('bottom-nav', {
    attrs: {
      "footerColor": "white"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 230 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [_vm._t("parallax-bg"), _vm._v(" "), _c('div', {
    class: _vm.defaultSwiperClasses.wrapperClass
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("pagination"), _vm._v(" "), _vm._t("button-prev"), _vm._v(" "), _vm._t("button-next"), _vm._v(" "), _vm._t("scrollbar")], 2)
},staticRenderFns: []}

/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "explore"
  }, [_c('h2', {
    staticClass: "h-l explore-title"
  }, [_vm._v("explore")]), _c('div', {
    staticClass: "exploreContainer"
  }, [_c('swiper', {
    ref: "gallery",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.explore), function(item) {
    return _c('swiper-slide', {
      key: item.text
    }, [_c('a', {
      attrs: {
        "href": item.link
      }
    }, [_c('div', {
      staticClass: "slide"
    }, [_c('img', {
      staticClass: "cover",
      attrs: {
        "src": item.image_url,
        "alt": item.text
      }
    }), _c('div', {
      staticClass: "gradient"
    })]), _c('h2', {
      staticClass: "h-ml",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    })])])
  }), _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }), _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  })], 2)], 1)])
},staticRenderFns: []}

/***/ }),
/* 232 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('top-nav', {
    attrs: {
      "headerColor": "white"
    }
  }), (_vm.param === 'past') ? _c('exhibitions-past') : (_vm.param === 'traveling') ? _c('exhibitions-traveling') : (_vm.param === 'upcoming') ? _c('exhibitions-upcoming') : _c('exhibitions-year'), _c('bottom-nav', {
    attrs: {
      "footerColor": "white"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.slideClass
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 234 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blog"
  }, [_c('top-nav', {
    attrs: {
      "headerColor": "white"
    }
  }), (_vm.loading) ? _c('div', {
    staticClass: "placeholder"
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "content year month"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-3_xs-12"
  }, [_c('div', {
    staticClass: "titles"
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v("learn")]), _c('router-link', {
    attrs: {
      "to": {
        name: 'blog'
      }
    }
  }, [_c('h1', {
    staticClass: "h-xl category"
  }, [_vm._v("600state")])]), _c('h3', {
    staticClass: "h-sm desc"
  }, [_vm._v(_vm._s(_vm.description))]), _vm._l((_vm.categories), function(cat) {
    return _c('router-link', {
      key: cat,
      attrs: {
        "to": _vm.categoryLink(cat)
      }
    }, [_c('h3', {
      staticClass: "h-sm cat",
      class: {
        active: _vm.catActive(cat)
      }
    }, [_vm._v(_vm._s(cat))])])
  })], 2)]), _c('div', {
    staticClass: "col-9_xs-12"
  }, [_c('div', {
    staticClass: "grid no-margin"
  }, [(_vm.currentIndex === 0 && _vm.featuredActive === 'active') ? _c('div', {
    staticClass: "col-12_xs-12 featured"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'article',
        params: {
          category: _vm.getCat(_vm.featuredMain),
          article: _vm.featuredMain.uid
        }
      }
    }
  }, [_c('div', {
    staticClass: "screen-blog-featured"
  }, [(_vm.hero(_vm.featuredMain)) ? _c('img', {
    staticClass: "cover",
    attrs: {
      "src": _vm.heroImage(_vm.featuredMain),
      "alt": _vm.heroCaption(_vm.featuredMain)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "captions"
  }, [_c('h2', {
    staticClass: "h-l lh-95 title",
    domProps: {
      "innerHTML": _vm._s(_vm.checkTitle(_vm.featuredMain))
    }
  }), (_vm.featuredMain.content.author.length > 0) ? _c('h2', {
    staticClass: "h-md author"
  }, [_vm._v(_vm._s(_vm.featuredMain.content.author) + " "), _c('br'), _vm._v("\n" + _vm._s(_vm.featuredMain.content.date))]) : _c('h2', {
    staticClass: "h-md author"
  }, [_vm._v(_vm._s(_vm.featuredMain.content.date))])])])])], 1) : _vm._e(), _vm._l((_vm.featured), function(post) {
    return (_vm.currentIndex === 0 && _vm.featuredActive === 'active') ? _c('div', {
      staticClass: "col-6_xs-12 featured"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'article',
          params: {
            category: _vm.getCat(post),
            article: post.uid
          }
        }
      }
    }, [_c('div', {
      staticClass: "screen-small"
    }, [(_vm.hero(post)) ? _c('img', {
      staticClass: "cover",
      attrs: {
        "src": _vm.heroImage(post),
        "alt": _vm.heroCaption(post)
      }
    }) : _vm._e(), _c('div', {
      staticClass: "captions"
    }, [_c('h2', {
      staticClass: "h-l lh-95 title",
      domProps: {
        "innerHTML": _vm._s(_vm.checkTitle(post))
      }
    }), (post.content.author.length > 0) ? _c('h2', {
      staticClass: "h-md author"
    }, [_vm._v(_vm._s(post.content.author) + " "), _c('br'), _vm._v("\n" + _vm._s(post.content.date))]) : _c('h2', {
      staticClass: "h-md author"
    }, [_vm._v(_vm._s(post.content.date))])])])])], 1) : _vm._e()
  }), _vm._l((_vm.posts), function(post) {
    return _c('div', {
      staticClass: "col-6_xs-12"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'article',
          params: {
            category: _vm.getCat(post),
            article: post.uid
          }
        }
      }
    }, [_c('div', {
      staticClass: "screen-small"
    }, [(_vm.hero(post)) ? _c('img', {
      staticClass: "cover",
      attrs: {
        "src": _vm.heroImage(post),
        "alt": _vm.heroCaption(post)
      }
    }) : _vm._e(), _c('div', {
      staticClass: "captions"
    }, [_c('h2', {
      staticClass: "h-l lh-95 title",
      domProps: {
        "innerHTML": _vm._s(_vm.checkTitle(post))
      }
    }), (post.content.author.length > 0) ? _c('h2', {
      staticClass: "h-md author"
    }, [_vm._v(_vm._s(post.content.author) + " "), _c('br'), _vm._v("\n" + _vm._s(post.content.date))]) : _c('h2', {
      staticClass: "h-md author"
    }, [_vm._v(_vm._s(post.content.date))])])])])], 1)
  })], 2)])]), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-3_xs-12"
  }), _c('div', {
    staticClass: "col-9_xs-12"
  }, [_c('div', {
    staticClass: "index"
  }, _vm._l((_vm.numPages), function(page) {
    return _c('p', {
      class: {
        active: _vm.active(page)
      },
      on: {
        "click": function($event) {
          _vm.loadPage(page)
        }
      }
    }, [_vm._v(_vm._s(page + 1))])
  }))])])]) : _vm._e()]), _c('bottom-nav', {
    attrs: {
      "footerColor": "white"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 235 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('top-nav', {
    attrs: {
      "headerColor": "white"
    }
  }), (_vm.loading) ? _c('div', {
    staticClass: "placeholder"
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "content programs-overview"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-4_xs-12 titles"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'programs'
      }
    }
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v("programs")])]), _c('h1', {
    staticClass: "h-sm category"
  }, [_vm._v(_vm._s(_vm.categoryName))])], 1), _c('div', {
    staticClass: "col-8_xs-12 week"
  }, [_c('div', {
    staticClass: "grid no-margin"
  }, [(_vm.noEvents) ? _c('div', {
    staticClass: "col-8_xs-12"
  }, [_c('h3', {
    staticClass: "h-xl"
  }, [_vm._v("Sorry!")]), _c('p', {
    staticClass: "h-sm"
  }, [_vm._v("There are no " + _vm._s(_vm.category.toLowerCase()) + " events scheduled. Check back soon, or sign up for our newsletter below to get regular updates.")])]) : _vm._e(), _vm._l((_vm.data), function(program) {
    return _c('div', {
      staticClass: "col-8_xs-12"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'programs-page',
          params: {
            category: _vm.programCategory(program),
            id: program.uid
          }
        }
      }
    }, [_c('h3', {
      staticClass: "h-m"
    }, [_vm._v(_vm._s(program.title))]), _c('h4', {
      staticClass: "h-sm"
    }, [_vm._v(_vm._s(program.content.date))]), _c('p', {
      staticClass: "h-sxx"
    }, [_vm._v(_vm._s(program.content.start_time) + " - " + _vm._s(program.content.end_time))])])], 1)
  })], 2), _c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "arrow left",
    on: {
      "click": _vm.prevPage
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/icons/left_arrow.svg"
    }
  })]), _vm._l((_vm.numPages), function(page) {
    return _c('p', {
      class: {
        active: _vm.active(page)
      },
      on: {
        "click": function($event) {
          _vm.loadPage(page)
        }
      }
    }, [_vm._v(_vm._s(page + 1))])
  }), _c('div', {
    staticClass: "arrow",
    on: {
      "click": _vm.nextPage
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/icons/right_arrow.svg"
    }
  })])], 2)])])]) : _vm._e()]), _c('bottom-nav', {
    attrs: {
      "footerColor": "white"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 236 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticClass: "placeholder"
  }) : _vm._e(), (!_vm.loading) ? _c('div', {
    staticClass: "content year"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-3 titles"
  }, [_c('router-link', {
    attrs: {
      "to": {
        "path": "/exhibitions"
      }
    }
  }, [_c('h1', {
    staticClass: "h-l"
  }, [_vm._v("exhibitions")])]), _c('h4', {
    staticClass: "h-sm status"
  }, [_vm._v(_vm._s(_vm.$route.params.year))])], 1), _c('div', {
    staticClass: "col-9_xs-12"
  }, [(_vm.exhibitions.length > 0) ? _c('div', {
    staticClass: "grid no-margin"
  }, _vm._l((_vm.exhibitions), function(exhibition) {
    return _c('div', {
      staticClass: "col-6_xs-12"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: _vm.year(exhibition.content.start_date) + '/' + exhibition.uid
        }
      }
    }, [_c('div', {
      staticClass: "screen-small"
    }, [_c('img', {
      staticClass: "cover",
      attrs: {
        "src": exhibition.image,
        "alt": exhibition.content.title
      }
    }), _c('div', {
      staticClass: "captions"
    }, [_c('h2', {
      staticClass: "title h-l italic"
    }, [_vm._v(_vm._s(exhibition.content.title))]), _c('h2', {
      staticClass: "dates h-sm"
    }, [_vm._v(_vm._s(_vm.displayDate(exhibition)))])])])])], 1)
  })) : _c('div', {
    staticClass: "grid no-margin"
  }, [_c('div', {
    staticClass: "col-9_xs-12"
  }, [_c('h2', {
    staticClass: "standin"
  }, [_vm._v("Traveling exhibitions coming soon ...")])])])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 237 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.loading) ? _c('footer', {
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "desktop",
    class: {
      white: _vm.whiteFooter
    }
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('button', {
    staticClass: "subscribe ag bold h-xl",
    class: {
      grey: _vm.whiteFooter
    },
    attrs: {
      "aria-label": "open newsletter subscribe modal"
    },
    on: {
      "click": function($event) {
        _vm.subscribe = true
      }
    }
  }, [_vm._v("join our newsletter")]), _c('div', {
    staticClass: "social"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/caaminla",
      "target": "_blank",
      "aria-label": "Link to CAAM Facebook Page"
    }
  }, [_c('figure', [_c('img', {
    attrs: {
      "src": _vm.facebook,
      "alt": "facebook icon"
    }
  })])]), _c('a', {
    attrs: {
      "href": "https://twitter.com/caaminla",
      "target": "_blank",
      "aria-label": "Link to CAAM Twitter Page"
    }
  }, [_c('figure', [_c('img', {
    attrs: {
      "src": _vm.twitter,
      "alt": "twitter icon"
    }
  })])]), _c('a', {
    attrs: {
      "href": "https://www.instagram.com/caaminla/",
      "target": "_blank",
      "aria-label": "Link to CAAM Instagram Page"
    }
  }, [_c('figure', [_c('img', {
    attrs: {
      "src": _vm.insta,
      "alt": "instagram icon"
    }
  })])]), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/channel/UCxbgXMDaQPRWeBxTd85HtFg",
      "target": "_blank",
      "aria-label": "Link to CAAM Youtube Page"
    }
  }, [_c('figure', [_c('img', {
    attrs: {
      "src": _vm.youtube,
      "alt": "youtube icon"
    }
  })])])]), _vm._m(0), _vm._m(1)]), _c('div', {
    staticClass: "col-9",
    class: {
      grey: _vm.subscribe
    }
  }, [(!_vm.subscribe) ? _c('div', {
    staticClass: "grid nav no-margin"
  }, _vm._l((_vm.mapRoot()), function(items) {
    return _c('div', {
      staticClass: "col-4"
    }, [_c('ul', _vm._l((items), function(item) {
      return _c('li', [_c('router-link', {
        attrs: {
          "to": {
            name: item.uid
          }
        }
      }, [_c('h3', {
        staticClass: "h-l"
      }, [_vm._v(_vm._s(item.title))])]), _c('ul', {
        attrs: {
          "id": "subnav"
        }
      }, _vm._l((item.children), function(child) {
        return _c('li', [((item.uid !== 'exhibitions' && item.uid !== 'programs' && item.uid !== 'learn' && item.uid !== 'about')) ? _c('router-link', {
          staticClass: "h-sx",
          attrs: {
            "to": {
              name: ((item.uid) + "-page"),
              params: {
                id: _vm.formatRoute(child.uid)
              }
            }
          }
        }, [_vm._v(_vm._s(child.title.toLowerCase()))]) : _vm._e(), (item.uid === 'exhibitions') ? _c('router-link', {
          staticClass: "h-sx",
          attrs: {
            "to": {
              name: ("" + (item.uid)),
              query: {
                status: _vm.formatRoute(child.uid)
              }
            }
          }
        }, [_vm._v(_vm._s(child.title.toLowerCase()))]) : _vm._e(), (item.uid === 'programs') ? _c('router-link', {
          staticClass: "h-sx",
          attrs: {
            "to": {
              name: ((item.uid) + "-overview"),
              params: {
                category: _vm.formatRoute(child.uid)
              }
            }
          }
        }, [_vm._v(_vm._s(child.title.toLowerCase()))]) : _vm._e(), (item.uid === 'learn' && child.uid === '600state') ? _c('router-link', {
          staticClass: "h-sx",
          attrs: {
            "to": {
              name: 'blog'
            }
          }
        }, [_vm._v(_vm._s(child.title.toLowerCase()))]) : (item.uid === 'learn' && child.uid !== '600state') ? _c('router-link', {
          staticClass: "h-sx",
          attrs: {
            "to": {
              name: ((item.uid) + "-page"),
              params: {
                id: _vm.formatRoute(child.uid)
              }
            }
          }
        }, [_vm._v(_vm._s(child.title.toLowerCase()))]) : ((item.uid === 'about' && child.uid !== 'subscribe')) ? _c('router-link', {
          staticClass: "h-sx",
          attrs: {
            "to": {
              name: ((item.uid) + "-page"),
              params: {
                id: _vm.formatRoute(child.uid)
              }
            }
          }
        }, [_vm._v(_vm._s(child.title.toLowerCase()))]) : ((item.uid === 'about' && child.uid === 'subscribe')) ? _c('p', {
          staticClass: "h-sx",
          on: {
            "click": _vm.subs
          }
        }, [_vm._v(_vm._s(child.title.toLowerCase()))]) : _vm._e()], 1)
      }))], 1)
    }))])
  })) : _vm._e(), (_vm.subscribe) ? _c('div', {
    staticClass: "newsletter"
  }, [(!_vm.message) ? _c('form', [_c('fieldset', [_c('legend', {
    staticClass: "dn"
  }, [_vm._v("Subscribe to Newsletter")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))]), _c('label', {
    staticClass: "dn",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Email")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('email')
    },
    attrs: {
      "type": "text",
      "placeholder": "email",
      "name": "email",
      "title": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('label', {
    staticClass: "dn",
    attrs: {
      "for": "firstname"
    }
  }, [_vm._v("First Name")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.first),
      expression: "first"
    }],
    attrs: {
      "type": "text",
      "placeholder": "first name",
      "name": "firstname",
      "title": "First Name"
    },
    domProps: {
      "value": (_vm.first)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.first = $event.target.value
      }
    }
  }), _c('label', {
    staticClass: "dn",
    attrs: {
      "for": "lastname"
    }
  }, [_vm._v("Last Name")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.last),
      expression: "last"
    }],
    attrs: {
      "type": "text",
      "placeholder": "last name",
      "name": "lastname",
      "title": "Last Name"
    },
    domProps: {
      "value": (_vm.last)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.last = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('zip')),
      expression: "errors.has('zip')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('zip')))]), _c('label', {
    staticClass: "dn",
    attrs: {
      "for": "zip"
    }
  }, [_vm._v("Zip")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zip),
      expression: "zip"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('numeric'),
      expression: "'numeric'"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('zip')
    },
    attrs: {
      "type": "text",
      "placeholder": "zip code",
      "name": "zip",
      "title": "Zip"
    },
    domProps: {
      "value": (_vm.zip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.zip = $event.target.value
      }
    }
  }), _c('button', {
    attrs: {
      "type": "button",
      "aria-label": "Subscribe to Newsletter"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("subscribe!")])])]) : _vm._e(), (_vm.message) ? _c('div', {
    staticClass: "message"
  }, [_c('h2', [_vm._v(_vm._s(_vm.message))])]) : _vm._e(), _c('div', {
    staticClass: "x",
    on: {
      "click": _vm.xOut
    }
  }, [_c('visual', {
    attrs: {
      "image": "/static/icons/x_out.svg",
      "alt": "exit newsletter signup"
    }
  })], 1)]) : _vm._e()])]), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "logo-container"
  }, [(!_vm.whiteFooter) ? _c('div', {
    attrs: {
      "id": "logo-bottom"
    }
  }, [_c('visual', {
    attrs: {
      "image": "/static/logos/caam_logo_white.svg",
      "alt": "Caam Logo"
    }
  })], 1) : _vm._e(), (_vm.whiteFooter) ? _c('div', {
    attrs: {
      "id": "logo-bottom"
    }
  }, [_c('visual', {
    attrs: {
      "image": "/static/logos/caam_logo.svg",
      "alt": "Caam Logo"
    }
  })], 1) : _vm._e()])]), _c('div', {
    staticClass: "col-9"
  }, [_c('div', {
    attrs: {
      "id": "slogan-bottom"
    }
  }, [(!_vm.subscribe) ? _c('h4', {
    staticClass: "free h-l lh-8",
    class: {
      white: _vm.whiteFooter
    }
  }, [_vm._v("art. history. culture.")]) : _vm._e()])])])]), _c('div', {
    staticClass: "mobile",
    class: {
      white: _vm.whiteFooter
    }
  }, [_c('button', {
    staticClass: "subscribe ag bold h-xl",
    class: {
      grey: _vm.whiteFooter
    },
    attrs: {
      "aria-label": "open newsletter subscribe modal"
    },
    on: {
      "click": function($event) {
        _vm.subscribe = true
      }
    }
  }, [_vm._v("join our newsletter")]), (_vm.subscribe) ? _c('div', {
    staticClass: "newsletter grey"
  }, [(!_vm.message) ? _c('form', [_c('fieldset', [_c('legend', {
    staticClass: "dn"
  }, [_vm._v("Subscribe to Newsletter")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))]), _c('label', {
    staticClass: "dn",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('email')
    },
    attrs: {
      "type": "text",
      "placeholder": "email",
      "name": "email",
      "title": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('zip')),
      expression: "errors.has('zip')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('zip')))]), _c('label', {
    staticClass: "dn",
    attrs: {
      "for": "zip"
    }
  }, [_vm._v("Zip")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zip),
      expression: "zip"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('numeric'),
      expression: "'numeric'"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('zip')
    },
    attrs: {
      "type": "text",
      "placeholder": "zip code",
      "name": "zip",
      "title": "Zip"
    },
    domProps: {
      "value": (_vm.zip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.zip = $event.target.value
      }
    }
  }), _c('button', {
    attrs: {
      "type": "button",
      "aria-label": "Subscribe to Newsletter"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("subscribe!")]), (_vm.message) ? _c('div', {
    staticClass: "message"
  }, [_c('h2', [_vm._v(_vm._s(_vm.message))])]) : _vm._e(), _c('div', {
    staticClass: "x",
    on: {
      "click": _vm.xOut
    }
  }, [_c('visual', {
    attrs: {
      "image": "/static/icons/x_out.svg",
      "alt": "exit newsletter signup"
    }
  })], 1)])]) : _vm._e()]) : _vm._e(), _c('p', {
    staticClass: "hours body",
    class: {
      white: _vm.whiteFooter
    }
  }, [_c('strong', [_vm._v("Hours ")]), _c('br'), _vm._v("\nGalleries Open "), _c('br'), _vm._v("\nTuesdays-Saturdays 10:00 a.m.-5:00 p.m. "), _c('br'), _vm._v("\nSundays 11:00 a.m.-5:00 p.m.")]), _vm._m(2), _vm._m(3), _c('p', {
    staticClass: "address body"
  }, [_vm._v("600 State Drive, Exposition Park, Los Angeles, CA 90037")]), _c('div', {
    staticClass: "social"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/caaminla",
      "target": "_blank",
      "aria-label": "Link to CAAM Facebook Page"
    }
  }, [_c('figure', [_c('img', {
    attrs: {
      "src": _vm.facebook,
      "alt": "facebook icon"
    }
  })])]), _c('a', {
    attrs: {
      "href": "https://twitter.com/caaminla",
      "target": "_blank",
      "aria-label": "Link to CAAM Twitter Page"
    }
  }, [_c('figure', [_c('img', {
    attrs: {
      "src": _vm.twitter,
      "alt": "twitter icon"
    }
  })])]), _c('a', {
    attrs: {
      "href": "https://www.instagram.com/caaminla/",
      "target": "_blank",
      "aria-label": "Link to CAAM Instagram Page"
    }
  }, [_c('figure', [_c('img', {
    attrs: {
      "src": _vm.insta,
      "alt": "instagram icon"
    }
  })])]), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/channel/UCxbgXMDaQPRWeBxTd85HtFg",
      "target": "_blank",
      "aria-label": "Link to CAAM Youtube Page"
    }
  }, [_c('figure', [_c('img', {
    attrs: {
      "src": _vm.youtube,
      "alt": "youtube icon"
    }
  })])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "covid-19",
    attrs: {
      "aria-label": "Link to CDPH covid-19 Info Page"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.cdph.ca.gov/covid19",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/icons/cdph-button.jpg",
      "alt": "CDPH icon"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hours body"
  }, [_c('strong', [_vm._v(" Hours ")]), _vm._v(" "), _c('br'), _vm._v("\nGalleries Open "), _c('br'), _vm._v("\nTuesdays-Saturdays "), _c('br'), _vm._v("\n10:00 a.m.-5:00 p.m. "), _c('br'), _vm._v("\nSundays "), _c('br'), _vm._v("\n11:00 a.m.-5:00p.m.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "covid-19",
    attrs: {
      "aria-label": "Link to CDPH covid-19 Info Page"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.cdph.ca.gov/covid19",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/icons/cdph-button.jpg",
      "alt": "CDPH icon"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "h-xxl lh-8"
  }, [_vm._v("California "), _c('br'), _vm._v("\nAfrican American "), _c('br'), _vm._v("\nMuseum")])
}]}

/***/ }),
/* 238 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      bgblack: _vm.introBG
    }
  }, [_c('transition', {
    attrs: {
      "name": "slideUp"
    }
  }, [(_vm.intro) ? _c('div', {
    staticClass: "welcome",
    attrs: {
      "aria-label": "Welcome Screen, press enter key to enter the site."
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "intro"
  }, [_c('div', {
    staticClass: "screen"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": _vm.introImage
    }
  })]), _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": "static/logos/caam_logo_white.svg",
      "alt": "Image of Caam Logo which spells CAAM."
    }
  })]), _c('button', {
    staticClass: "next",
    attrs: {
      "role": "Button",
      "aria-label": "Click or press enter to enter the site."
    },
    on: {
      "click": _vm.enter
    }
  }, [_c('img', {
    attrs: {
      "src": "static/icons/arrow_down_white.svg",
      "alt": "Downfacing Triangle"
    }
  })])]) : _vm._e()])], 1) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "slideUpOffset"
    }
  }, [(!_vm.intro) ? _c('div', {
    staticClass: "main"
  }, [_c('top-nav', {
    attrs: {
      "headerColor": "black"
    }
  }), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "home"
  }, [_c('home-exhibition', {
    key: "first",
    attrs: {
      "exhibition": _vm.exhibitionFirst
    }
  }), (!_vm.introBG) ? _c('div', [_vm._l((_vm.exhibitions), function(exhibition) {
    return _c('home-exhibition', {
      key: _vm.title(exhibition),
      attrs: {
        "exhibition": exhibition
      }
    })
  }), (_vm.programs.length > 0) ? _c('home-events', {
    attrs: {
      "programs": _vm.programs
    }
  }) : _vm._e(), _c('home-explore', {
    attrs: {
      "explore": _vm.explore
    }
  })], 2) : _vm._e()], 1) : _vm._e()]), (!_vm.introBG) ? _c('bottom-nav', {
    attrs: {
      "footerColor": "black"
    }
  }) : _vm._e()], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 239 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticClass: "placeholder"
  }) : _vm._e(), (!_vm.loading) ? _c('div', {
    staticClass: "content past"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-4_xs-12 titles"
  }, [_c('router-link', {
    attrs: {
      "to": {
        "path": "/exhibitions"
      }
    }
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v("exhibitions")])]), _c('h4', {
    staticClass: "status h-sm"
  }, [_vm._v("past")])], 1), _c('div', {
    staticClass: "col-8 years",
    attrs: {
      "data-push-left": "off-0_xs-4"
    }
  }, _vm._l((_vm.years), function(year) {
    return _c('router-link', {
      key: year.title,
      staticClass: "h-l bold",
      attrs: {
        "to": {
          name: 'exhibitions-overview',
          params: {
            year: year.title
          }
        }
      }
    }, [_vm._v(_vm._s(year.title))])
  }))])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 240 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('top-nav', {
    attrs: {
      "headerColor": "white"
    }
  }), (_vm.loading) ? _c('div', {
    staticClass: "placeholder"
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "content index"
  }, [_c('div', {
    staticClass: "grid top-margin-8"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h1', {
    staticClass: "h-xl category",
    style: (_vm.textColor)
  }, [_vm._v(_vm._s(_vm.title))])]), _c('div', {
    staticClass: "col-12 hero-row"
  }, [_c('div', {
    staticClass: "hero"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": _vm.heroImage,
      "alt": _vm.heroAlt
    }
  })])]), _c('div', {
    staticClass: "col-8_xs-12",
    attrs: {
      "data-push-left": "off-4_xs-0"
    }
  }, [_c('div', {
    staticClass: "copy wysiwyg",
    domProps: {
      "innerHTML": _vm._s(_vm.content.main_text)
    }
  }), _c('div', {
    staticClass: "grid no-margin"
  }, _vm._l((_vm.children), function(child) {
    return _c('div', {
      staticClass: "col-6_xs-12"
    }, [_c('div', {
      staticClass: "page"
    }, [_c('router-link', {
      attrs: {
        "to": _vm.route(child.uid)
      }
    }, [_c('div', {
      staticClass: "captions-mobile"
    }, [_c('h2', {
      staticClass: "subpage h-l"
    }, [_vm._v(_vm._s(child.content.title.toLowerCase()))])]), _c('div', {
      staticClass: "screen-smaller",
      style: (_vm.backgroundColor)
    }, [(_vm.pageHero(child.content.main_image, child.files)) ? _c('img', {
      staticClass: "cover",
      attrs: {
        "src": _vm.pageHero(child.content.main_image, child.files),
        "alt": child.content.title.toLowerCase()
      }
    }) : _vm._e(), (!_vm.pageHero(child.content.main_image, child.files)) ? _c('div', {
      staticClass: "imageless"
    }) : _vm._e(), _c('div', {
      staticClass: "captions",
      class: {
        gradient: _vm.pageHero(child.content.main_image, child.files)
      }
    }, [_c('h2', {
      staticClass: "subpage h-l"
    }, [_vm._v(_vm._s(child.content.title.toLowerCase()))])])])])], 1)])
  }))])])]) : _vm._e()]), _c('bottom-nav', {
    attrs: {
      "footerColor": "white"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 241 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticClass: "placeholder"
  }) : _vm._e(), (!_vm.loading) ? _c('div', {
    staticClass: "content year"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-3 titles"
  }, [_c('router-link', {
    attrs: {
      "to": {
        "path": "/exhibitions"
      }
    }
  }, [_c('h1', {
    staticClass: "h-l"
  }, [_vm._v("exhibitions")])]), _c('h4', {
    staticClass: "status"
  }, [_vm._v(_vm._s(_vm.$route.params.year))])], 1), _c('div', {
    staticClass: "col-9_xs-12"
  }, [_c('div', {
    staticClass: "grid no-margin"
  }, _vm._l((_vm.exhibitions), function(exhibition) {
    return _c('div', {
      staticClass: "col-6_xs-12"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: exhibition.content.year + '/' + exhibition.uid
        }
      }
    }, [_c('div', {
      staticClass: "screen-small"
    }, [_c('img', {
      staticClass: "cover",
      attrs: {
        "src": exhibition.image,
        "alt": exhibition.content.title
      }
    }), _c('div', {
      staticClass: "captions"
    }, [_c('h2', {
      staticClass: "title h-l italic"
    }, [_vm._v(_vm._s(exhibition.content.title))]), _c('h2', {
      staticClass: "dates h-sm"
    }, [_vm._v(_vm._s(_vm.displayDate(exhibition)))])])])])], 1)
  }))])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 242 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('top-nav', {
    attrs: {
      "headerColor": "white"
    }
  }), (_vm.loading) ? _c('div', {
    staticClass: "placeholder"
  }) : _vm._e(), (!_vm.loading) ? _c('div', {
    staticClass: "content exhibitions"
  }, [_c('div', {
    staticClass: "grid"
  }, [_vm._m(0), _c('div', {
    staticClass: "col-12"
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "screen"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'exhibition-single',
        params: {
          year: _vm.startYear(_vm.current.main),
          id: _vm.current.main.uid
        }
      }
    }
  }, [_c('div', {
    staticClass: "screen-image"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": _vm.current.main.image,
      "alt": _vm.altText
    }
  }), _c('div', {
    staticClass: "captions-main"
  }, [_c('h2', {
    staticClass: "h-xl italic"
  }, [_vm._v(_vm._s(_vm.title(_vm.current.main)))]), _c('h2', {
    staticClass: "h-l"
  }, [_vm._v(_vm._s(_vm.displayDate(_vm.current.main)))])])])])], 1) : _vm._e()]), _vm._l((_vm.current.exhibitions), function(exhibition) {
    return _c('div', {
      staticClass: "col-6_xs-12"
    }, [(!_vm.loading) ? _c('div', {
      key: _vm.title(exhibition),
      staticClass: "screen"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'exhibition-single',
          params: {
            year: _vm.startYear(exhibition),
            id: exhibition.uid
          }
        }
      }
    }, [_c('div', {
      staticClass: "screen-image"
    }, [_c('img', {
      staticClass: "cover",
      attrs: {
        "src": exhibition.image,
        "alt": exhibition.title
      }
    }), _c('div', {
      staticClass: "captions"
    }, [_c('h2', {
      staticClass: "h-xl italic"
    }, [_vm._v(_vm._s(_vm.title(exhibition)))]), _c('h2', {
      staticClass: "h-l"
    }, [_vm._v(_vm._s(_vm.displayDate(exhibition)))])])])])], 1) : _vm._e()])
  })], 2), _c('div', {
    staticClass: "grid",
    attrs: {
      "id": "further-exhibitions"
    }
  }, [_c('div', {
    staticClass: "col-6_xs-12"
  }, [_c('h2', {
    staticClass: "h-l",
    attrs: {
      "id": "upcoming"
    }
  }, [_vm._v("upcoming")]), (!_vm.loading) ? _c('div', {
    staticClass: "half-screen"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'exhibitions-overview',
        params: {
          year: 'upcoming'
        }
      }
    }
  }, [_c('div', {
    staticClass: "screen-image"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": _vm.upcomingFeatured,
      "alt": "Upcoming Exhibitions"
    }
  })])])], 1) : _vm._e()]), (_vm.traveling.image) ? _c('div', {
    staticClass: "col-6_xs-12"
  }, [_c('h2', {
    staticClass: "h-l",
    attrs: {
      "id": "traveling"
    }
  }, [_vm._v("traveling")]), (!_vm.loading) ? _c('div', {
    staticClass: "half-screen"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'exhibitions-overview',
        params: {
          year: 'traveling'
        }
      }
    }
  }, [_c('div', {
    staticClass: "screen-image"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": _vm.travelingFeatured,
      "alt": "Traveling Exhibitions"
    }
  })])])], 1) : _vm._e()]) : _vm._e(), _c('div', {
    staticClass: "col-6_xs-12"
  }, [_c('h2', {
    staticClass: "h-l",
    attrs: {
      "id": "past"
    }
  }, [_vm._v("past")]), (!_vm.loading) ? _c('div', {
    staticClass: "half-screen"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'exhibitions-overview',
        params: {
          year: 'past'
        }
      }
    }
  }, [_c('div', {
    staticClass: "screen-image"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": _vm.pastFeatured,
      "alt": "Past Exhibitions"
    }
  })])])], 1) : _vm._e()])])]) : _vm._e(), _c('bottom-nav', {
    attrs: {
      "footerColor": "white"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 no-bottom"
  }, [_c('h1', {
    staticClass: "category h-xl"
  }, [_vm._v("exhibitions")]), _c('h2', {
    staticClass: "h-l",
    attrs: {
      "id": "current"
    }
  }, [_vm._v("on view")])])
}]}

/***/ }),
/* 243 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    staticClass: "input",
    class: _vm.inputClass,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}

/***/ }),
/* 244 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 245 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('top-nav', {
    attrs: {
      "headerColor": "white"
    }
  }), (_vm.loading) ? _c('div', {
    staticClass: "placeholder"
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "content info"
  }, [_c('div', {
    staticClass: "grid-noBottom margin-top-12"
  }, [_c('div', {
    staticClass: "col-4_xs-12 titles"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.category
      }
    }
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v(_vm._s(_vm.category))])]), (_vm.subpage) ? _c('router-link', {
    attrs: {
      "to": {
        path: '/' + _vm.parent
      }
    }
  }, [_c('h3', {
    staticClass: "h-sm parent",
    style: (_vm.textColor)
  }, [_vm._v(_vm._s(_vm.parentTitle.toLowerCase()))])]) : _vm._e(), _c('h1', {
    staticClass: "h-xl",
    style: (_vm.textColor)
  }, [_vm._v(_vm._s(_vm.loadedData[_vm.key].title))]), _c('ul', _vm._l((_vm.children), function(child) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          path: '/' + child.uri
        }
      }
    }, [_c('h3', {
      staticClass: "h-sm"
    }, [_vm._v(_vm._s(child.content.title.toLowerCase()))])])], 1)
  })), _c('h4', {
    staticClass: "h-sm share",
    on: {
      "click": function($event) {
        _vm.share = !_vm.share
      }
    }
  }, [_vm._v("share"), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.share) ? _c('social', {
    attrs: {
      "meta": _vm.shareInfo
    }
  }) : _vm._e()], 1)], 1)], 1), (_vm.url) ? _c('div', {
    staticClass: "col-8_xs-12 rc"
  }, [_c('div', {
    staticClass: "hero"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": _vm.url,
      "alt": _vm.parentTitle
    }
  })]), (_vm.heroCaptions) ? _c('div', {
    staticClass: "captions-hero"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.heroCaptions)
    }
  })]) : _vm._e()]) : _vm._e(), (_vm.url) ? _c('div', {
    staticClass: "col-5_xs-12 rc",
    attrs: {
      "data-push-left": "off-4_xs-0"
    }
  }, [_c('div', {
    staticClass: "copy wysiwyg",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), (_vm.gallery) ? _c('swiper', {
    ref: "info-gallery",
    staticClass: "gallery",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.gallery), function(image) {
    return _c('swiper-slide', {
      key: image.title
    }, [_c('div', {
      staticClass: "slide"
    }, [_c('img', {
      staticClass: "cover",
      attrs: {
        "src": image.url
      }
    })])])
  }), _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }), _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  })], 2) : _vm._e()], 1) : _c('div', {
    staticClass: "col-5_xs-12 rc"
  }, [_c('div', {
    staticClass: "copy wysiwyg no-hero",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), (_vm.gallery) ? _c('swiper', {
    ref: "info-gallery",
    staticClass: "gallery",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.gallery), function(image) {
    return _c('swiper-slide', {
      key: image.title
    }, [_c('div', {
      staticClass: "slide"
    }, [_c('img', {
      staticClass: "cover",
      attrs: {
        "src": image.url
      }
    })])])
  }), _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }), _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  })], 2) : _vm._e()], 1), _c('div', {
    staticClass: "col-3_xs-12 rc"
  }, [_c('div', {
    staticClass: "box wysiwyg",
    domProps: {
      "innerHTML": _vm._s(_vm.box)
    }
  })])])]) : _vm._e()]), _c('bottom-nav', {
    attrs: {
      "footerColor": "white"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 246 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticClass: "placeholder"
  }) : _vm._e(), (!_vm.loading) ? _c('div', {
    staticClass: "content year"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-3_xs-12 titles"
  }, [_c('router-link', {
    attrs: {
      "to": {
        "path": "/exhibitions"
      }
    }
  }, [_c('h1', {
    staticClass: "h-l"
  }, [_vm._v("exhibitions")])]), _c('h4', {
    staticClass: "status"
  }, [_vm._v(_vm._s(_vm.$route.params.year))])], 1), (_vm.exhibitions.length > 0) ? _c('div', {
    staticClass: "col-9_xs-12"
  }, [_c('div', {
    staticClass: "grid no-margin"
  }, _vm._l((_vm.exhibitions), function(exhibition) {
    return _c('div', {
      staticClass: "col-6_xs-12"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: _vm.year + '/' + exhibition.uid
        }
      }
    }, [(_vm.hero(exhibition)) ? _c('div', {
      staticClass: "screen-small"
    }, [_c('img', {
      staticClass: "cover",
      attrs: {
        "src": _vm.hero(exhibition),
        "alt": _vm.altText(exhibition)
      }
    }), _c('div', {
      staticClass: "captions"
    }, [_c('h2', {
      staticClass: "title h-l italic"
    }, [_vm._v(_vm._s(exhibition.content.title))]), _c('h2', {
      staticClass: "dates h-sm"
    }, [_vm._v(_vm._s(_vm.date(exhibition)))])])]) : _vm._e(), (!_vm.hero(exhibition)) ? _c('div', {
      staticClass: "screen-small"
    }, [_c('img', {
      staticClass: "cover",
      attrs: {
        "src": "/static/images/sun.jpg",
        "alt": _vm.altText(exhibition)
      }
    }), _c('div', {
      staticClass: "noimagecaptions"
    }, [_c('h2', {
      staticClass: "title h-l italic"
    }, [_vm._v(_vm._s(exhibition.content.title))]), _c('h2', {
      staticClass: "dates h-sm"
    }, [_vm._v(_vm._s(_vm.date(exhibition)))])])]) : _vm._e()])], 1)
  }))]) : _c('div', {
    staticClass: "col-9_xs-12"
  }, [_c('h2', {
    staticClass: "standin"
  }, [_vm._v("Full exhibitions list coming soon ...")])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 247 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('top-nav', {
    attrs: {
      "headerColor": "white"
    }
  }), (_vm.loading) ? _c('div', {
    staticClass: "placeholder"
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "content search"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-4_xs-12 titles"
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v("search")])]), (_vm.results) ? _c('div', {
    staticClass: "col-8_xs-12 results"
  }, [_c('div', {
    staticClass: "grid"
  }, _vm._l((_vm.loadedData), function(item) {
    return _c('div', {
      staticClass: "col-8_xs-12"
    }, [_c('router-link', {
      attrs: {
        "to": _vm.path(item)
      }
    }, [_c('h2', {
      staticClass: "h-m",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }), _c('p', {
      staticClass: "h-sxx",
      domProps: {
        "innerHTML": _vm._s(_vm.text(item))
      }
    })])], 1)
  }))]) : _c('div', {
    staticClass: "col-8_xs-12 results"
  }, [_c('h3', {
    staticClass: "sorry h-m"
  }, [_vm._v("Sorry!")]), _c('p', [_vm._v("We couldn't find any results.")])])])]) : _vm._e()]), _c('bottom-nav', {
    attrs: {
      "footerColor": "white"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 248 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "social"
  }, [_c('a', {
    attrs: {
      "href": _vm.facebookUrl,
      "target": "_blank",
      "aria-label": "Share Page to Facebook"
    }
  }, [_vm._m(0)]), _c('a', {
    attrs: {
      "href": _vm.twitterUrl,
      "target": "_blank",
      "aria-label": "Share Page to Twitter"
    }
  }, [_vm._m(1)]), _c('a', {
    attrs: {
      "href": _vm.emailUrl,
      "aria-label": "Share Page via Email"
    }
  }, [_vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', [_c('img', {
    attrs: {
      "src": "/static/icons/facebook.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', [_c('img', {
    attrs: {
      "src": "/static/icons/twitter.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', [_c('img', {
    attrs: {
      "src": "/static/icons/email.svg"
    }
  })])
}]}

/***/ }),
/* 249 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.wrap ? 'WrapperInput' : 'SingleInput', {
    tag: "component",
    attrs: {
      "value": _vm.date,
      "placeholder": _vm.placeholder,
      "inputClass": _vm.inputClass,
      "alignment": _vm.alignment
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 250 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "control has-addons flatpickr",
    class: ( _obj = {}, _obj[("has-addons-" + _vm.alignment)] = _vm.alignment, _obj ),
    attrs: {
      "data-wrap": "true",
      "data-clickOpens": "false"
    }
  }, [_c('input', {
    staticClass: "input",
    class: _vm.inputClass,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder,
      "data-input": ""
    },
    domProps: {
      "value": _vm.value
    }
  }), _vm._v(" "), _vm._t("default")], 2)
  var _obj;
},staticRenderFns: []}

/***/ }),
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[86]);


// WEBPACK FOOTER //
// static/js/app-v188.js